let config = require("../config.js");
let COLORS = require("../data/colors.js");
let UTILS = require("./utils.js");
const THREE = require("three");
let prefabs = new (require("../data/prefabs.js"))();
var medals = require("../data/medals.js");
let vO311 = {
  HELPER: require("./overlayHelpers.js"),
  scale: 1
};
var v9892;
let v9893 = vO311.canvas = document.getElementById("game-overlay");
let v9894 = vO311.ctx = v9893.getContext("2d");
vO311.resize = function () {
  v9893.width = window.innerWidth;
  v9893.height = window.innerHeight;
};
vO311.resize();
const Minimap = require("./Minimap.js");
vO311.miniMap = new Minimap();
let v9895 = new Image();
v9895.onload = () => v9895.isReady = true;
v9895.src = "./img/muzflash.png";
vO311.updateMuzzle = p12446 => {
  v9895.isReady = false;
  v9895.onload = () => v9895.isReady = true;
  v9895.src = p12446;
};
let v9896 = new Image();
v9896.onload = () => v9896.isReady = true;
v9896.src = UTILS.assetsUrl("/textures/marker_0.png");
let v9897 = new Image();
v9897.onload = () => v9897.isReady = true;
v9897.src = UTILS.assetsUrl("/textures/marker_0_next.png");
vO311.updateObjectiveMarker = p12447 => {
  v9896.isReady = false;
  v9896.onload = () => v9896.isReady = true;
  v9896.src = p12447;
};
vO311.updateNextObjectiveMarker = p12448 => {
  v9897.isReady = false;
  v9897.onload = () => v9897.isReady = true;
  v9897.src = p12448;
};
vO311.sprayList = [];
vO311.sprayWheel = false;
vO311.sprayWheelTimer = 0;
vO311.sprayWheelIndex = 15;
vO311.sprayWheelMax = 15;
vO311.sprayWheelReq = 200;
vO311.sprayWheelUpdate = p12449 => {
  if (vO311.sprayWheel) {
    vO311.sprayWheelTimer += p12449;
  }
};
vO311.sprayWheelClose = () => {
  vO311.sprayWheelTimer = 0;
  vO311.sprayWheel = false;
};
vO311.getSprayIndex = () => {
  var v9898 = vO311.sprayWheelIndex;
  return vO311.sprayList[v9898];
};
vO311.sprayWheelOpened = () => vO311.sprayWheelTimer >= vO311.sprayWheelReq && vO311.sprayWheel;
vO311.sprayWheelOpen = () => vO311.sprayWheel = true;
vO311.sprayWheelChange = p12450 => {
  var v9899 = vO311.sprayWheelIndex;
  v9899 += p12450;
  if (v9899 > vO311.sprayWheelMax) {
    v9899 = 0;
  }
  if (v9899 < 0) {
    v9899 = vO311.sprayWheelMax;
  }
  vO311.sprayWheelIndex = v9899;
  window.playTick();
};
vO311.propList = prefabs.props;
vO311.propWheel = false;
vO311.propWheelTimer = 0;
vO311.propWheelIndex = 0;
vO311.propWheelMax = prefabs.props.length - 1;
vO311.propWheelReq = 200;
vO311.propWheelUpdate = p12451 => {
  if (vO311.propWheel) {
    vO311.propWheelTimer += p12451;
  }
};
vO311.propWheelClose = () => {
  vO311.propWheelTimer = 0;
  vO311.propWheel = false;
};
vO311.getPropIndex = () => vO311.propList[vO311.propWheelIndex];
vO311.pickRandomProp = () => {
  var v9900 = UTILS.randInt(0, vO311.propList.length - 1);
  vO311.propWheelIndex = v9900;
  return vO311.propList[v9900];
};
vO311.propWheelOpened = () => vO311.propWheelTimer >= vO311.propWheelReq && vO311.propWheel;
vO311.propWheelOpen = () => vO311.propWheel = true;
vO311.propWheelChange = p12452 => {
  var v9901 = vO311.propWheelIndex;
  v9901 += p12452;
  if (v9901 > vO311.propWheelMax) {
    v9901 = 0;
  }
  if (v9901 < 0) {
    v9901 = vO311.propWheelMax;
  }
  vO311.propWheelIndex = v9901;
  window.playTick();
};
vO311.bloodCustom = false;
vO311.bloodOpacity = 0;
vO311.bloodImage = new Image();
vO311.bloodImage.onload = () => vO311.bloodImage.isReady = true;
vO311.bloodImage.src = "./img/blood.png";
let vA549 = [new Image(), new Image(), new Image()];
vA549[0].onload = () => vA549[0].isReady = true;
vA549[0].src = UTILS.assetsUrl("/textures/flag_r.png");
vA549[1].onload = () => vA549[1].isReady = true;
vA549[1].src = UTILS.assetsUrl("/textures/flag_b.png");
vA549[2].onload = () => vA549[2].isReady = true;
vA549[2].src = UTILS.assetsUrl("/textures/flag_w.png");
vO311.updateFlagMarker = (p12453, p12454) => {
  vA549[p12454].isReady = false;
  vA549[p12454].onload = () => vA549[p12454].isReady = true;
  vA549[p12454].src = p12453;
};
let vA550 = [vO311.HELPER.loadImg(UTILS.assetsUrl("/textures/jugg_1.png")), vO311.HELPER.loadImg(UTILS.assetsUrl("/textures/jugg_2.png"))];
let vO312 = {
  vic: {},
  dra: {},
  def: {}
};
Object.keys(vO312).forEach(p12455 => {
  vO312[p12455] = new Image();
  vO312[p12455].onload = () => vO312[p12455].isReady = true;
  vO312[p12455].src = "./img/" + p12455 + ".png";
});
vO311.medalsList = ["Humiliation", "Promotion", "First Blood", "Revenge", "Bullseye", "Beatdown", "Execution", "No Scope", "Quick Scope", "Headshot", "Wallbang", "Longshot", "Snatched", "Close Call", "Comeback", "Buzzkill", "Driftkill", "Mid Air", "Turbo Kill", "Bomb Planted", "Secured", "Team Work", "Capture", "Return", "Pickup", "Defender", "Attacker", "Clock Work", "Recharge", "Denied", "Confirmed", "Assist", "Double Kill", "Triple Kill", "Quad Kill", "Multi Kill", "Mega Kill", "Ultra Kill", "Super Kill", "Leveled Up", "Nuked", "Boosted", "Sleight of Hand", "Rapid Fire", "Siphon", "Rooted", "Dizzy", "Poisoned", "Collected", "Deposited", "Bombed", "Jump Boost", "Zapped", "Strength", "Scavenger", "Cycled"];
let v9902 = vO311.HELPER.loadImg(UTILS.assetsUrl("/img/medals/badge_0.png"));
let vA551 = [];
vO311.updateMedalIcon = (p12456, p12457) => {
  if (p12457 == -1) {
    v9902 = vO311.HELPER.patchImg(UTILS.assetsUrl("/img/medals/badge_0.png"), p12456);
  } else if (vO311.medalsList[p12457]) {
    vA551[p12457] = vO311.HELPER.patchImg(UTILS.assetsUrl("/img/medals/medal_" + p12457 + ".png"), p12456);
  }
};
var v9903 = null;
vO311.divs = [];
vO311.kpdData = null;
vO311.hideNames = false;
vO311.deathMarkerOpacity = 1;
vO311.deathMarkerAdsOpacity = 0.5;
vO311.deathMarkerDisplay = 0;
vO311.deathMarkerDuration = 7;
vO311.showDMG = true;
vO311.dmgNums = [];
vO311.showFlash = false;
vO311.flashX = 0;
vO311.flashY = 0;
vO311.fakeCross = false;
vO311.crosshairType = 1;
vO311.dmgColor = "white";
vO311.critColor = "white";
vO311.healColor = "#03fc30";
vO311.crosshairColor = "white";
vO311.crosshairShadow = "black";
vO311.crosshairShadowThickness = 1;
vO311.crosshairOpacity = 0;
vO311.crosshairUseOpacityCustom = false;
vO311.crosshairOpacityCustom = 0;
vO311.crosshairScale = 0;
vO311.crosshairAlways = false;
vO311.dynamicHP = true;
vO311.dmgScale = 30;
vO311.crosshairStyle = 1;
vO311.crosshairThick = 2;
vO311.crosshairLen = 16;
vO311.crosshairGap = 0;
vO311.crosshairDot = true;
vO311.crosshairImage = new Image();
vO311.crosshairImageW = 0;
vO311.crosshairImageH = 0;
vO311.mapCross = null;
vO311.mapCrossChase = null;
vO311.nametagStyle = 0;
vO311.nametagOpacity = 1;
vO311.nametagScale = 1;
vO311.healthNum = false;
vO311.healthColT = COLORS.teams[0];
vO311.healthColE = COLORS.teams[1];
vO311.adsObjectiveOpacity = 0.5;
vO311.objectiveOpacity = 1;
vO311.scopeBorders = {
  color: "#000000",
  display: true
};
vO311.crosshairColorM = "white";
vO311.crosshairShadowM = "black";
vO311.crosshairLenM = 16;
vO311.crosshairThickM = 3;
vO311.crosshairUseOpacityCustomM = false;
vO311.crosshairOpacityCustomM = 0;
vO311.crosshairAlwaysM = false;
vO311.crosshairShadowThicknessM = 1;
vO311.crosshairGapM = 14;
vO311.crosshairDotM = true;
vO311.crosshairTypeM = 3;
vO311.crosshairImageM = new Image();
vO311.crosshairImageWM = 0;
vO311.crosshairImageHM = 0;
vO311.crosshairStyleM = 1;
vO311.kpdVision = true;
vO311.kpdVisionCol = "#00ffff";
vO311.interactProg = {
  color: "#ffffff",
  display: false,
  left: 50,
  top: 80,
  width: 400,
  height: 30,
  prog: 0,
  opacity: 1,
  rot: 0
};
vO311.captureProg = {
  color: "#ffffff",
  left: 50,
  top: 80,
  width: 400,
  height: 30,
  opacity: 1,
  rot: 0,
  scale: 0.8
};
vO311.interactMProg = {
  color: "#ffffff",
  oColor: "#eb2f2f",
  display: false,
  scale: 0.5,
  left: 56,
  top: 50,
  width: 400,
  height: 30,
  prog: 0,
  opacity: 1,
  rot: 0
};
vO311.scoreText = {
  color: "#ffea78",
  text: "",
  opacity: 0,
  textAlign: "center",
  top: 37,
  left: 50,
  display: false
};
vO311.timerText = {
  color: "#fff",
  text: "",
  opacity: 0,
  textAlign: "center",
  top: 26,
  left: 50,
  display: false
};
vO311.infoText = {
  color: "#fff",
  width: 460,
  height: 100,
  text: "",
  opacity: 0.5,
  textAlign: "center",
  top: "215px",
  left: 50,
  display: false
};
vO311.infoSub = {
  color: "#fbc02d",
  width: 330,
  height: 60,
  text: "",
  opacity: 0.5,
  textAlign: "center",
  top: "280px",
  left: 50,
  display: false
};
vO311.checkText = {
  color: "#40C4FF",
  text: "",
  opacity: 0,
  textAlign: "center",
  top: 20,
  left: 50,
  display: false
};
vO311.chalName = {
  color: "#fff",
  text: "",
  text2: "",
  fontSize: 80,
  width: 517,
  height: 167,
  lineHeight: 150,
  opacity: 0,
  textAlign: "center",
  top: "80px",
  left: 50,
  display: false,
  rect: {
    color: null
  }
};
vO311.vicTitle = {
  type: "vic",
  show: false,
  opacity: {
    val: 0,
    increment: 0.05
  },
  scale: {
    val: 2.5,
    decrement: 0.005,
    acc: 0.01
  }
};
vO311.medals = [];
vO311.medalPrefab = {
  medal: true,
  marginName: 40,
  marginScore: 70,
  marginCount: 30,
  size: 130,
  scale: 1,
  border: 7,
  offset: {
    x: 0,
    y: -5
  },
  left: 50,
  top: 8,
  opacity: 0,
  zoomInc: 0.06,
  zoom: 2,
  soundN: null,
  sound: true,
  count: 1,
  filter: null
};
vO311.hitmarker = {
  image: null,
  opacity: 0,
  width: 105,
  height: 105,
  display: false,
  custom: false
};
var vO313 = {};
vO311.hitSet = {
  enabled: true,
  opacity: 1
};
vO311.showHit = p12458 => {
  if (vO311.hitSet.enabled) {
    vO313.active = true;
    vO313.opacity = vO311.hitSet.opacity;
    vO313.spacing = vO311.hitSet.spacing;
    vO313.inc = vO311.hitSet.inc;
    vO313.length = p12458 ? vO311.hitSet.length * 1.2 : vO311.hitSet.length;
    vO313.colors = p12458 ? vO311.hitSet.kColors : vO311.hitSet.colors;
  }
};
function f1557(p12459, p12460, p12461, p12462, p12463, p12464, p12465) {
  let v9904 = p12459.createLinearGradient(p12460, p12461, p12460 + (p12464 == "X" ? p12462 : 0), p12461 + (p12464 == "Y" ? p12463 : 0));
  p12465.forEach((p12466, p12467) => v9904.addColorStop(p12467, p12466));
  p12459.fillStyle = v9904;
  p12459.fillRect(p12460, p12461, p12462, p12463);
}
function f1558(p12468, p12469, p12470, p12471) {
  if (vO313.active) {
    if (vO313.opacity > 0 && (vO313.spacing += vO311.hitSet.inc * p12471, vO313.inc -= vO311.hitSet.speed * p12471, vO313.opacity -= vO311.hitSet.fadeOut * p12471, vO313.opacity = Math.max(vO313.opacity, 0), vO313.opacity <= 0)) {
      vO313.active = false;
      return;
    } else {
      p12468.save(1);
      p12468.translate(p12469 / 2, p12470 / 2);
      p12468.rotate(Math.PI / 4);
      p12468.globalAlpha = vO313.opacity;
      f1557(p12468, -(vO311.hitSet.thickness / 2), -(vO313.length / 2) - vO313.spacing, vO311.hitSet.thickness, vO313.length, "Y", vO313.colors[0]);
      f1557(p12468, -(vO311.hitSet.thickness / 2), -(vO313.length / 2) + vO313.spacing, vO311.hitSet.thickness, vO313.length, "Y", vO313.colors[1]);
      f1557(p12468, -(vO313.length / 2) - vO313.spacing, -(vO311.hitSet.thickness / 2), vO313.length, vO311.hitSet.thickness, "X", vO313.colors[0]);
      f1557(p12468, -(vO313.length / 2) + vO313.spacing, -(vO311.hitSet.thickness / 2), vO313.length, vO311.hitSet.thickness, "X", vO313.colors[1]);
      p12468.restore(-1);
      return;
    }
  } else {
    return undefined;
  }
}
function f1559(p12472) {
  return p12472.slice(0, -1) + String.fromCharCode(65 + UTILS.randInt(0, 5));
}
var vO314 = {
  center: true,
  center_marker: true,
  height: 24,
  y: -2,
  speed_scale: 1,
  speed_y: 1,
  speedPX: 24,
  enabled: true,
  hudScale: 0.5,
  neutralZoneCol: "#4C4C4C",
  gainZoneCol: "#34FD34",
  outlineCol: "#000000",
  speedCol: "#FDFDFD",
  prestrafeCol: "#ffd026"
};
vO311.drawSRM = (p12473, p12474, p12475) => {
  if (p12473 && p12473.overlayInfo) {
    var v9905;
    var v9906;
    var v9907;
    var v9908;
    var v9909 = (p12475 - vO314.height) / 2 + vO314.y;
    var vLN01588 = 0;
    if (vO314.center) {
      vLN01588 = -p12473.overlayInfo.c;
    }
    if (p12473.overlayInfo.mi < p12473.overlayInfo.o) {
      v9905 = p12473.overlayInfo.mi + vLN01588;
      v9907 = p12473.overlayInfo.o - p12473.overlayInfo.mi;
    } else {
      v9905 = p12473.overlayInfo.o + vLN01588;
      v9907 = p12473.overlayInfo.mi - p12473.overlayInfo.o;
    }
    if (p12473.overlayInfo.o < p12473.overlayInfo.ma) {
      v9906 = p12473.overlayInfo.o + vLN01588;
      v9908 = p12473.overlayInfo.ma - p12473.overlayInfo.o;
    } else {
      v9906 = p12473.overlayInfo.ma + vLN01588;
      v9908 = p12473.overlayInfo.o - p12473.overlayInfo.ma;
    }
    if (v9905 && v9907 && v9906 && v9908 && p12473.overlayInfo.c) {
      v9894.clearRect(0, p12475 / 2 - vO314.height / 2 - 4, p12474, vO314.height + 8);
      v9894.lineWidth = 1;
      v9894.fillStyle = vO314.gainZoneCol;
      v9894.strokeStyle = vO314.outlineCol;
      v9894.fillRect(UTILS.AngleToPixel(v9906, vO314.hudScale, p12474), v9909, UTILS.AngleDiffToPixelDiff(v9908, vO314.hudScale, p12474), vO314.height);
      v9894.strokeRect(UTILS.AngleToPixel(v9906, vO314.hudScale, p12474), v9909, UTILS.AngleDiffToPixelDiff(v9908, vO314.hudScale, p12474), vO314.height);
      v9894.fillStyle = vO314.neutralZoneCol;
      v9894.fillRect(UTILS.AngleToPixel(v9905, vO314.hudScale, p12474), v9909, UTILS.AngleDiffToPixelDiff(v9907, vO314.hudScale, p12474), vO314.height);
      v9894.strokeRect(UTILS.AngleToPixel(v9905, vO314.hudScale, p12474), v9909, UTILS.AngleDiffToPixelDiff(v9907, vO314.hudScale, p12474), vO314.height);
      if (vO314.center_marker) {
        v9894.fillStyle = vO314.marker;
        v9894.fillRect(UTILS.AngleToPixel(p12473.overlayInfo.c + vLN01588, vO314.hudScale, p12474) - 0.5, v9909 + vO314.height / 2, 2, vO314.height / 2);
      }
    }
  }
};
var vLN01589 = 0;
var vLN01590 = 0;
vO311.speedDisplay = {
  color: "#ffea78",
  colorMax: "#ff0000",
  curr: 0,
  max: 0,
  display: false,
  fontSize: 24,
  opacity: 1,
  top: 54,
  left: 50,
  update: 0
};
function f1560(p12476, p12477, p12478, p12479, p12480, p12481) {
  if (vO311.speedDisplay.display) {
    vO311.speedDisplay.update -= p12479;
    if (vO311.speedDisplay.update <= 0) {
      var vLN01591 = 0;
      vO311.speedDisplay.update = 100;
      if (p12481 && p12481.active && !p12480.moveLock) {
        vLN01591 = UTILS.getD3D(0, 0, 0, p12481.velocity.x, 0, p12481.velocity.z);
      }
      var v9910 = Math.round(vLN01591 * 1000);
      if (v9910 > vLN01590) {
        vLN01590 = v9910;
      }
      vLN01589 = v9910;
    }
    p12476.save(1);
    p12476.globalAlpha = vO311.speedDisplay.opacity;
    p12476.translate(UTILS.calcPercent(p12477, vO311.speedDisplay.left), UTILS.isNumber(vO311.speedDisplay.top) ? UTILS.calcPercent(p12478, vO311.speedDisplay.top) : +vO311.speedDisplay.top.replace("px", ""));
    p12476.font = vO311.speedDisplay.fontSize + "px GameFont";
    p12476.textBaseline = "middle";
    let v9911 = p12476.measureText(vLN01589).width;
    let v9912 = p12476.measureText(vLN01590).width;
    let v9913 = v9911 + v9912 + 5;
    p12476.fillStyle = f1559(vO311.speedDisplay.color);
    p12476.fillText(vLN01589, 0 - v9913 / 2, 0);
    p12476.fillStyle = f1559(vO311.speedDisplay.colorMax);
    p12476.fillText(vLN01590, 0 + v9913 / 2 - v9912, 0);
    p12476.restore(-1);
  }
}
vO311.reset = () => {
  for (var vLN01592 = 0; vLN01592 < vO311.divs.length; ++vLN01592) {
    vO311.divs[vLN01592].display = false;
  }
  vO311.divs.length = 0;
};
vO311.animateText = (p12482, p12483, p12484, p12485, p12486, p12487, p12488, p12489, p12490, p12491) => {
  if (vO311.divs.indexOf(p12482) < 0) {
    vO311.divs.push(p12482);
  }
  p12482.delay = p12488;
  if (!p12488) {
    p12482.display = true;
  }
  p12482.fontSize = p12484;
  p12482.scale = p12484;
  p12482.shadow = p12491 || 0;
  p12482.minScale = p12485 ? p12484 * (p12490 || 0.4) : p12484;
  p12482.text = p12483;
  p12482.scaleSpeed = p12485;
  p12482.life = p12486;
  p12482.fade = p12487;
  p12482.opacity = 1;
  p12482.callback = p12489;
};
vO311.animateMedal = (p12492, p12493, p12494, p12495, p12496, p12497, p12498, p12499, p12500) => {
  if (vO311.divs.indexOf(p12492) < 0) {
    vO311.divs.push(p12492);
  }
  p12492.delay = p12499;
  if (!p12499) {
    p12492.display = true;
  }
  p12492.fontSize = p12495;
  p12492.scale = p12495;
  p12492.minScale = p12496 ? p12495 * 0.4 : p12495;
  p12492.text = p12493.toUpperCase();
  p12492.text2 = p12494 ? p12494.toUpperCase() : null;
  p12492.scaleSpeed = p12496;
  p12492.life = p12497;
  p12492.fade = p12498;
  p12492.opacity = 1;
  p12492.callback = p12500;
};
vO311.animateMedalNew = (p12501, p12502, p12503, p12504, p12505, p12506, p12507, p12508, p12509) => {
  var v9914 = vO311.medalsList[p12502];
  if (vO311.divs.indexOf(p12501) < 0) {
    vO311.divs.push(p12501);
  }
  p12501.delay = p12508;
  if (!p12508) {
    p12501.display = true;
  }
  p12501.score = p12503 ? p12503.toUpperCase() : null;
  p12501.name = v9914.toUpperCase();
  p12501.index = p12502;
  p12501.opacity = 0;
  p12501.zoom = 1.5;
  if (!vA551[p12502]) {
    vA551[p12502] = vO311.HELPER.loadImg(UTILS.assetsUrl("/img/medals/medal_" + p12502 + ".png"));
  }
  p12501.icon = vA551[p12502];
  p12501.life = p12506;
  p12501.fade = p12507;
  p12501.soundN = UTILS.isNumber(p12504) ? "medal_" + (p12504 || 0) : null;
  p12501.opacity = 1;
  p12501.count = p12505 || 1;
  p12501.callback = p12509;
  if (!p12508 && p12501.soundN && p12501.sound) {
    SOUND.play(p12501.soundN, 0.08);
  }
};
vO311.animateDiv = (p12510, p12511, p12512, p12513, p12514) => {
  if (vO311.divs.indexOf(p12510) < 0) {
    vO311.divs.push(p12510);
  }
  p12510.display = true;
  p12510.life = p12511;
  p12510.maxLife = p12511;
  p12510.opacity = 1;
  p12510.fade = p12512;
  if (p12513) {
    p12510.width = p12513;
    p12510.height = p12513;
    p12510.startS = p12513;
    p12510.scaleSpd = p12514;
  }
};
vO311.dmgVal = (p12515, p12516, p12517, p12518, p12519, p12520) => {
  if (vO311.showDMG) {
    v9903 = null;
    for (var vLN01593 = 0; vLN01593 < vO311.dmgNums.length; ++vLN01593) {
      if (!vO311.dmgNums[vLN01593].life) {
        v9903 = vO311.dmgNums[vLN01593];
        break;
      }
    }
    if (!v9903) {
      v9903 = {};
      vO311.dmgNums.push(v9903);
    }
    v9903.heal = p12520;
    v9903.crit = p12519;
    v9903.life = 1000;
    v9903.x = p12515;
    v9903.y = p12516 + 7;
    v9903.z = p12517;
    v9903.dir = UTILS.randFloat(-Math.PI, Math.PI);
    v9903.val = Math.abs(p12518);
  }
};
var vA552 = [];
var vLN50 = 50;
vO311.speedLineMlt = 500;
Number.prototype.map = function (p12521, p12522, p12523, p12524) {
  return (this - p12521) * (p12524 - p12523) / (p12522 - p12521) + p12523;
};
function f1561() {
  this.life = 0;
  this.init = function (p12525, p12526, p12527, p12528) {
    this.x = p12525;
    this.y = p12526;
    this.speed = p12527.map(0, 400, 2, 8);
    this.life = this.startLife = UTILS.randInt(500, 1100);
    this.alpha = UTILS.randFloat(Math.max(0, vO311.shoSpdLines - 0.4), vO311.shoSpdLines) * Math.min(1, (p12527 - vLN50) / 50);
    this.angle = Math.PI * UTILS.randFloat(0, 2);
    this.size = p12527.map(0, 350, 1, 400);
    this.inRadius = p12527.map(0, 400, 550, 350);
    this.outRadius = p12528;
  };
  this.update = function (ctx, delta) {
    this.life -= this.speed * delta;
    this.inRadius += this.speed * delta;
    this.alpha *= this.life / this.startLife;
    this.size *= this.life / this.startLife;
    this.render(ctx);
  };
  this.render = function (ctx) {
    ctx.save(1);
    ctx.translate(this.x, this.y);
    ctx.rotate(this.angle);
    ctx.beginPath();
    ctx.moveTo(0, this.inRadius);
    ctx.lineTo(this.size, this.outRadius);
    ctx.lineTo(-this.size, this.outRadius);
    ctx.closePath();
    ctx.fillStyle = "rgba(" + vO311.spdLinesCol + ", " + this.alpha + ")";
    ctx.fill();
    ctx.restore(-1);
  };
}
vO311.shoSpdLines = 0;
vO311.spdLinesCol = "230,230,230";
for (var vLN01594 = 0; vLN01594 < 15; ++vLN01594) {
  vA552.push(new f1561());
}
function f1562(p12532, p12533, p12534, p12535, p12536) {
  if (vO311.shoSpdLines && p12532 && p12532.active) {
    var v9915 = UTILS.getDistance(0, 0, p12532.velocity.x, p12532.velocity.z) * vO311.speedLineMlt;
    if (v9915 >= vLN50) {
      for (var vLN01595 = 0; vLN01595 < vA552.length; ++vLN01595) {
        if (vA552[vLN01595].life <= 0) {
          vA552[vLN01595].init(p12534 / 2, p12535 / 2, v9915, p12534);
        } else {
          vA552[vLN01595].update(p12533, p12536);
        }
      }
    }
  }
}
vO311.deathMarkers = [];
vO311.addDeathMarker = (p12537, p12538, p12539, p12540) => {
  if (vO311.deathMarkerDisplay != 3 && (vO311.deathMarkerDisplay != 1 || p12540) && (vO311.deathMarkerDisplay != 2 || !p12540)) {
    var v9916 = null;
    for (var vLN01596 = 0; vLN01596 < vO311.deathMarkers.length; ++vLN01596) {
      if (!vO311.deathMarkers[vLN01596].life) {
        v9916 = vO311.deathMarkers[vLN01596];
        break;
      }
    }
    if (!v9916) {
      v9916 = {};
      vO311.deathMarkers.push(v9916);
    }
    v9916.isYou = p12540;
    v9916.life = vO311.deathMarkerDuration;
    v9916.x = p12537;
    v9916.y = p12538;
    v9916.z = p12539;
  }
};
var v9917;
var vLN01597 = 0;
var vLN01598 = 0;
var vA553 = ["volume_down", "volume_up"];
var vLN01599 = 0;
var vLN01600 = 0;
var vA554 = ["hourglass_bottom", "hourglass_top"];
var v9918 = new THREE.Vector3();
var v9919 = v9894.createLinearGradient(0 - vO311.chalName.width / 2, 0, vO311.chalName.width / 2, 0);
v9919.addColorStop(0, "rgba(0,0,0,0)");
v9919.addColorStop(0.4, "rgba(0,0,0,0.3)");
v9919.addColorStop(0.6, "rgba(0,0,0,0.3)");
v9919.addColorStop(1, "rgba(0,0,0,0)");
vO311.chalName.rect.color = v9919;
vO311.hits = [];
vO311.showHits = true;
vO311.hitColor = "255,63,63";
function f1563(p12541, p12542, p12543, p12544, p12545) {
  if (!(p12544 <= 0)) {
    p12541.save(1);
    p12541.globalAlpha = p12544;
    p12541.fillStyle = "rgba(" + vO311.hitColor + ",1)";
    p12541.rotate((p12545 || 0) * Math.PI / 180 + Math.PI / 2);
    p12541.beginPath();
    var vLN01601 = 0;
    var v9920 = -(p12542 / 2) + p12543;
    p12541.lineTo(vLN01601, v9920);
    p12541.lineTo(vLN01601 + 10, v9920 + 20);
    p12541.lineTo(vLN01601 + 10 + 80, v9920 + 30 + 25);
    p12541.bezierCurveTo(vLN01601, v9920 + 25, vLN01601, v9920 + 25, vLN01601 - 10 - 80, v9920 + 30 + 25);
    p12541.lineTo(vLN01601 - 10, v9920 + 20);
    p12541.closePath();
    p12541.fill();
    p12541.restore(-1);
  }
}
vO311.rainbow = {
  col: "#ffffff",
  val: 0,
  freq: 1000 / 60,
  upd: 0
};
function f1564(p12546) {
  vO311.rainbow.val += p12546 * 0.3;
  if (vO311.rainbow.val >= 360) {
    vO311.rainbow.val = 0;
  }
  vO311.rainbow.upd -= p12546;
  if (vO311.rainbow.upd <= 0) {
    vO311.rainbow.upd = vO311.rainbow.freq;
    vO311.rainbow.col = UTILS.hexFromHue(Math.round(vO311.rainbow.val));
  }
}
vO311.resetAll = () => {
  customGUIHolder.innerHTML = "";
  vO311.customGUIs.length = 0;
  vO311.divsToUpd.length = 0;
  vO311.deathMarkers.length = 0;
};
vO311.customGUIs = [];
vO311.divsToUpd = [];
vO311.generateUIS = (p12547, p12548) => {
  vO311.customGUIs = p12547;
  for (var vLN01602 = 0; vLN01602 < p12547.length; ++vLN01602) {
    if (p12547[vLN01602].t == 3) {
      var v9921 = document.createElement("div");
      v9921.innerHTML = 0;
      v9921.style.opacity = parseFloat(p12547[vLN01602].o) || 0;
      v9921.style.width = parseFloat(p12547[vLN01602].w) || 0;
      v9921.style.height = parseFloat(p12547[vLN01602].h) || 0;
      v9921.style.top = (parseFloat(p12547[vLN01602].y) || 0) + "%";
      v9921.style.left = (parseFloat(p12547[vLN01602].x) || 0) + "%";
      v9921.style.fontSize = (p12547[vLN01602].f || 10) + "px";
      v9921.style.color = p12547[vLN01602].c || "#ff0000";
      v9921.style.zIndex = p12547[vLN01602].z || 0;
      v9921.style.position = "absolute";
      v9921.style.transform = "translate(-50%, -50%)";
      v9921.style.display = ~~!!parseInt(p12547[vLN01602].nv) ? "none" : "block";
      v9921.id = "cusDIV" + vLN01602;
      v9921.setAttribute("data-text", v9921.innerHTML);
      v9921.addEventListener("click", p12549 => {
        p12549.stopPropagation();
        p12549.cancelBubble = true;
        if (p12549 && p12549.target && p12548 && p12548.mainScript && p12548.mainScript.onDIVClicked) {
          p12548.mainScript.onDIVClicked(p12549.target.id);
        }
      });
      customGUIHolder.appendChild(v9921);
      vO311.divsToUpd.push({
        id: parseInt(p12547[vLN01602].id) || 0,
        elm: v9921,
        curr: v9921.innerHTML,
        data: p12547[vLN01602]
      });
    }
  }
};
let v9922 = new THREE.Vector3();
vO311.render = (p12550, game, p12552, p12553, p12554, p12555, p12556, p12557) => {
  'use strict';

  let vVO311 = vO311;
  vVO311.scale = p12550;
  let v9923 = v9893.width / p12550;
  let v9924 = v9893.height / p12550;
  let v9925 = endUI.style.display != "none" || menuHolder.style.display != "none";
  let v9926 = deathUIHolder.style.display == "none" && !v9925;
  let v9927 = p12553.camera.getWorldPosition(v9922);
  var v9928 = p12554 && p12554.team ? p12554.team : window.spectating ? 1 : 0;
  var v9929 = !p12553.aimRecticle.custom && p12553.aimRecticle.display && p12553.aimRecticle.opacity > 0 && p12553.aimRecticle.image && p12553.aimRecticle.image.isReady;
  vLN01598 -= p12555;
  if (vLN01598 <= 0) {
    vLN01598 = 300;
    vLN01597++;
    if (vLN01597 >= vA553.length) {
      vLN01597 = 0;
    }
  }
  vLN01600 -= p12555;
  if (vLN01600 <= 0) {
    vLN01600 = 800;
    vLN01599++;
    if (vLN01599 >= vA554.length) {
      vLN01599 = 0;
    }
  }
  v9894.save(1);
  v9894.scale(p12550, p12550);
  v9894.clearRect(0, 0, v9923, v9924);
  f1562(p12554, v9894, v9923, v9924, p12555);
  vO311.drawSRM(p12554, v9923, v9924);
  if (vO311.showHits) {
    v9894.save(1);
    v9894.translate(v9923 / 2, v9924 / 2);
    if (p12554 && p12554.active) {
      for (var vLN01620 = 0; vLN01620 < vVO311.hits.length; ++vLN01620) {
        if (vVO311.hits[vLN01620].life) {
          vVO311.hits[vLN01620].life -= p12555;
          if (vVO311.hits[vLN01620].life <= 0) {
            vVO311.hits[vLN01620].life = 0;
          }
          f1563(v9894, v9924 / 2, 83, vVO311.hits[vLN01620].life / config.hitLife, THREE.MathUtils.radToDeg(UTILS.getDir(vVO311.hits[vLN01620].x, vVO311.hits[vLN01620].z, p12554.x, p12554.z) + p12552.xDr));
        }
      }
    }
    v9894.restore(-1);
  }
  if (vO311.showDMG) {
    for (var vLN01620 = 0; vLN01620 < vO311.dmgNums.length; ++vLN01620) {
      v9892 = vO311.dmgNums[vLN01620];
      if (v9892.life) {
        v9892.life -= p12555;
        if (v9892.life <= 0) {
          v9892.life = 0;
        } else {
          v9892.y += p12555 * 0.022;
          v9892.x += p12555 * 0.013 * Math.cos(v9892.dir);
          v9892.z += p12555 * 0.013 * Math.sin(v9892.dir);
          v9918.set(v9892.x, v9892.y, v9892.z);
          if (!p12553.frustum.containPoint(v9918)) {
            continue;
          }
          v9894.save(1);
          v9918.project(p12553.camera);
          v9918.x = (v9918.x + 1) / 2;
          v9918.y = (v9918.y + 1) / 2;
          v9894.translate(Math.round(v9923 * v9918.x), Math.round(v9924 * (1 - v9918.y)));
          v9894.fillStyle = v9892.heal ? vO311.healColor : v9892.crit ? vO311.critColor : vO311.dmgColor;
          v9894.strokeStyle = "#2e2e2e";
          v9894.lineWidth = 5;
          v9894.font = vO311.dmgScale + "px GameFont";
          var v9930 = -Math.round(v9894.measureText(v9892.val).width / 2);
          v9894.strokeText(v9892.val, v9930 + 1, 0);
          v9894.fillText(v9892.val, v9930, 0);
          v9894.restore(-1);
        }
      }
    }
  }
  if (!v9925) {
    for (var vLN01620 = 0; vLN01620 < game.AI.ais.length; ++vLN01620) {
      v9892 = game.AI.ais[vLN01620];
      if (!v9892.active || !v9892.canBSeen || !v9892.mesh || !v9892.mesh.visible) {
        continue;
      }
      var v9931 = 1 + v9892.scale / 30;
      var v9945 = v9892.mesh.position.clone();
      v9945.y += v9892.height * (v9892.assetID ? 4 : 2) + config.nameOffset + 1.5;
      var v10027 = Math.max(0.3, 1 - UTILS.getD3D(v9927.x, v9927.y, v9927.z, v9945.x, v9945.y, v9945.z) / 600);
      var v9947 = v10027 * 20;
      var v10029 = v9947 >= 1 && p12553.frustum.containPoint(v9945);
      if (!v10029) {
        continue;
      }
      v9894.save(1);
      v9945.project(p12553.camera);
      v9945.x = (v9945.x + 1) / 2;
      v9945.y = (v9945.y + 1) / 2;
      v9894.translate(v9923 * v9945.x, v9924 * (1 - v9945.y));
      v9894.scale(v10027, v10027);
      let v9936 = v9931 * 20 + "px GameFont";
      let v9937 = v9931 * 120 * (v9892.tagScale || 1);
      let v9938 = (1 + (v9931 - 1) * 0.3) * 16;
      let v9939 = v9892.lvl || 0;
      if (v9939) {
        v9894.font = "30.25px GameFont";
        let vLN106 = 10;
        let v9940 = vLN106 * 1.5;
        let vLN107 = 10;
        let vLN502 = 50;
        let v9941 = v9894.measureText(v9939).width;
        v9894.fillStyle = "rgba(0, 0, 0, 0.65)";
        v9894.fillRect(-v9937 / 2 - vLN107 - v9941 - v9940, -(vLN502 + vLN106 / 2) - 3, v9941 + v9940, vLN502 + vLN106);
        v9894.fillStyle = "white";
        if (v9939 >= 99) {
          v9894.fillStyle = "#e834eb";
        } else if (v9939 >= 60) {
          v9894.fillStyle = "#eb9634";
        } else if (v9939 >= 30) {
          v9894.fillStyle = "#AC69B9";
        }
        v9894.fillText(v9939, -(v9937 / 2) - vLN107 - v9941 - v9940 / 2, -v9938 / 2);
      }
      if (v9892.maxHealth) {
        v9894.fillStyle = "rgba(0,0,0,0.4)";
        v9894.fillRect(-v9937 / 2, -v9938, v9937, v9938);
        var v9942 = (!v9892.team || !game.mode || !game.mode.teams || v9892.team != v9928) && (!game.mode || !game.mode.friendly || v9892.team != 1);
        v9894.fillStyle = v9942 ? vVO311.healthColE : vVO311.healthColT;
        v9894.fillRect(-v9937 / 2, -v9938, v9937 * (v9892.health / v9892.maxHealth), v9938);
      }
      v9894.font = v9936;
      let v9943 = v9892.name;
      v9894.fillStyle = "white";
      v9894.font = v9936;
      v9894.fillText(v9943, -(v9937 / 2), -v9938 - v9931 * 7);
      if (v9939 > 60) {
        var v10119 = vVO311.HELPER.loadImg("./img/skull_0.png");
        var vLN60 = 60;
        if (v10119.isReady) {
          v9894.drawImage(v10119, v9937 / 2 + 5, -vLN60, vLN60, vLN60);
        }
      }
      v9894.restore(-1);
    }
  }
  f1564(p12555);
  if (!v9925 && vVO311.nametagOpacity > 0) {
    for (var vLN01620 = 0; vLN01620 < game.players.list.length; ++vLN01620) {
      v9892 = game.players.list[vLN01620];
      if (v9892.active && (!game.controls || game.controls.spect.target != v9892) && !v9892.isYou && v9892.objInstances) {
        if (v9892.inView) {
          var v9945 = v9892.objInstances.position.clone();
          v9945.y += config.playerHeight + config.nameOffset - v9892.crouchVal * config.crouchDst;
          if (v9892.hatIndex >= 0 || v9892.headIndex >= 0) {
            v9945.y += config.nameOffsetHat;
          }
          v9945.y += config.headScale * v9892.headMlt - config.headScale;
          var v10027 = Math.max(0.3, 1 - UTILS.getD3D(v9927.x, v9927.y, v9927.z, v9945.x, v9945.y, v9945.z) / 600);
          var v9947 = v10027 * 20;
          var v10029 = v9947 >= 1 && p12553.frustum.containPoint(v9945);
          if (!v10029) {
            continue;
          }
          v9894.save(1);
          v9894.globalAlpha = vVO311.nametagOpacity;
          v10027 *= vVO311.nametagScale;
          v9945.project(p12553.camera);
          v9945.x = (v9945.x + 1) / 2;
          v9945.y = (v9945.y + 1) / 2;
          v9894.translate(v9923 * v9945.x, v9924 * (1 - v9945.y));
          v9894.scale(v10027, v10027);
          var v9949 = !game.mode.noHPbars;
          let vLN1302 = 130;
          let v9950 = vO311.nametagStyle != 1 && v9949 ? 16 : 6;
          if (v9949 && (vO311.nametagStyle == 0 || vO311.nametagStyle == 3)) {
            v9894.fillStyle = "rgba(0, 0, 0, 0.4)";
            v9894.fillRect(-vLN1302 / 2, -v9950, vLN1302, v9950);
            if (vVO311.dynamicHP && v9892.hpChase > v9892.health / v9892.maxHealth) {
              v9894.fillStyle = "#FFFFFF";
              v9894.fillRect(-vLN1302 / 2, -v9950, vLN1302 * v9892.hpChase, v9950);
            }
            v9894.fillStyle = f1559(v9928 == v9892.team || game.mode && game.mode.fakeNames && v9928 != 2 ? vVO311.healthColT : vVO311.healthColE);
            if (vVO311.kpdData && vVO311.kpdVision && window.spectating && game.controls.spect.target) {
              let v9951 = game.controls.spect.target;
              if (v9951 && v9892.id !== v9951.id && (!v9951.team || v9951.team != v9892.team)) {
                var v9952 = game.canSee(v9951, v9892.x, v9892.y, v9892.z);
                if (v9952 == null) {
                  v9894.fillStyle = vVO311.kpdVisionCol;
                }
              }
            }
            v9894.fillRect(-vLN1302 / 2, -v9950, vLN1302 * (v9892.health / v9892.maxHealth), v9950);
            if (vO311.healthNum) {
              v9894.save(1);
              v9894.globalAlpha = vVO311.nametagOpacity;
              v9894.fillStyle = "white";
              v9894.font = "9px GameFont";
              v9894.fillText(v9892.health.round(1), -vLN1302 / 2 + 2, -3);
              v9894.restore(-1);
            }
          }
          if (vO311.nametagStyle < 3) {
            let v9953 = vO311.hideNames ? "Player " + v9892.sid : v9892.premiumT ? v9892.alias : v9892.name;
            let v9954 = vO311.hideNames ? null : v9892.clan ? v9892.clan + "" : null;
            let v9955 = game.isComp ? 0 : v9892.level;
            var vLSWhite = "white";
            var v9956 = COLORS.getClanCol(v9892.clan, null);
            let v9957 = v9892.featured ? "check_circle" : null;
            let v9958 = v9892.premiumT ? "beenhere" : null;
            let v9959 = v9892.partner == 2 ? "verified" : null;
            let v9960 = v9892.badgeIndex > -1;
            let v9961 = v9960 ? vVO311.HELPER.loadImg(game.badges[v9892.badgeIndex].url) : null;
            let vLS20pxGameFont = "20px GameFont";
            let vLS26pxMaterialIcons = "26px Material Icons";
            let vLS26pxMaterialIcons2 = "26px Material Icons";
            let vLS16pxGameFont = "16px GameFont";
            v9894.font = vLS16pxGameFont;
            let v9962 = v9955 && vO311.nametagStyle != 1 ? v9894.measureText(v9955).width : 0;
            v9894.font = vLS26pxMaterialIcons;
            let v9963 = v9957 ? v9894.measureText(v9957).width : 0;
            let v9964 = v9958 ? v9894.measureText(v9958).width : 0;
            let v9965 = v9959 ? v9894.measureText(v9959).width : 0;
            v9894.font = vLS20pxGameFont;
            let v9966 = Math.min(425, v9894.measureText(v9953).width) + (v9954 || v9957 || v9958 || v9959 || v9960 ? 5 : 0);
            let v9967 = v9954 ? Math.min(75, v9894.measureText(v9954).width) : 0;
            v9894.translate(0, -v9950 - 10);
            if (!v9949) {
              vLN1302 = v9966;
            }
            if (v9955 && vO311.nametagStyle != 1) {
              let vLN2010 = 20;
              let vLN108 = 10;
              let v9968 = vLN108 * 1.8;
              v9894.font = vLS16pxGameFont;
              v9894.fillStyle = "rgba(0, 0, 0, 0.65)";
              v9894.fillRect(-vLN1302 / 2 - v9962 - v9968, -(vLN2010 + vLN108 / 2) - 3, v9962 + v9968, vLN2010 + vLN108);
              v9894.fillStyle = vLSWhite;
              v9894.fillText(v9955, -vLN1302 / 2 - v9962 - v9968 / 2, -3);
            }
            v9894.fillStyle = vVO311.kpdData && vVO311.kpdData.sus == v9892.id ? "#eb5656" : "white";
            v9894.fillStyle = vVO311.kpdData && vVO311.kpdData.caller == v9892.id ? "#135DD8" : v9894.fillStyle;
            v9894.font = vLS20pxGameFont;
            v9894.globalAlpha = vVO311.nametagOpacity;
            v9894.fillText(v9953, -vLN1302 / 2 + (v9962 ? 5 : 0), 0, 425);
            v9894.globalAlpha = (v9956 ? 1 : 0.4) * vVO311.nametagOpacity;
            v9894.fillStyle = v9956 ? v9956 : "white";
            if (v9954) {
              v9894.fillText("[", -vLN1302 / 2 + (v9962 ? 5 : 0) + v9966, 0);
              v9894.fillText(v9954, -vLN1302 / 2 + (v9962 ? 5 : 0) + v9966 + v9894.measureText("[").width, 0, 75);
              v9894.fillText("]", -vLN1302 / 2 + (v9962 ? 5 : 0) + v9966 + v9894.measureText("[").width + v9967, 0);
              v9967 += v9894.measureText("[").width + v9894.measureText("]").width;
              v9967 += v9957 || v9958 || v9959 || v9960 ? 3 : 0;
            }
            const v9969 = p12557 && p12557[v9953] && p12557[v9953].length;
            const v9970 = v9892.isBusy;
            if (v9969) {
              v9894.save(1);
              v9894.globalAlpha = vVO311.nametagOpacity;
              v9894.font = "55px Material Icons";
              v9894.textAlign = "center";
              v9894.textBaseline = "middle";
              v9894.fillStyle = "#FFF";
              v9894.fillText(vA553[vLN01597], v9970 ? -25 : 0, -60);
              v9894.restore(-1);
            }
            if (v9970) {
              v9894.save(1);
              v9894.globalAlpha = vVO311.nametagOpacity;
              v9894.fillStyle = "#fbc02d";
              v9894.textAlign = "center";
              v9894.textBaseline = "middle";
              v9894.font = "55px Material Icons";
              v9894.fillText(vA554[vLN01599], v9969 ? 25 : 0, -60);
              v9894.restore(-1);
            }
            v9894.globalAlpha = vVO311.nametagOpacity;
            v9894.font = vLS26pxMaterialIcons2;
            v9894.fillStyle = COLORS.partner;
            if (v9959) {
              v9894.fillText(v9959, -vLN1302 / 2 + (v9962 ? 5 : 0) + v9966 + v9967, 1);
            }
            v9894.globalAlpha = vVO311.nametagOpacity;
            v9894.font = vLS26pxMaterialIcons2;
            v9894.fillStyle = COLORS.verified.clan;
            if (v9958) {
              v9894.fillText(v9958, -vLN1302 / 2 + (v9962 ? 5 : 0) + v9966 + v9967 + v9965 + 1, 1);
            }
            v9894.globalAlpha = vVO311.nametagOpacity;
            v9894.font = vLS26pxMaterialIcons;
            v9894.fillStyle = COLORS.verified.player;
            if (v9957) {
              v9894.fillText(v9957, -vLN1302 / 2 + (v9962 ? 5 : 0) + v9966 + v9967 + v9965 + 1 + v9964 + 1, 0);
            }
            v9894.globalAlpha = vVO311.nametagOpacity;
            if (v9960 && v9961 && v9961.isReady) {
              v9894.drawImage(v9961, -vLN1302 / 2 + (v9962 ? 5 : 0) + v9966 + v9967 + v9965 + 1 + v9964 + 1 + v9963 + 3, -24, 23, 23);
            }
          }
          v9894.restore(-1);
        }
        if (v9892.isJuggernaut && !v9892.inView && !UTILS.pointInBox3D(v9927.x, v9927.y, v9927.z, v9892)) {
          v9918.set(v9892.x, v9892.y + v9892.height / 2, v9892.z);
          var v10027 = Math.max(0.3, 1 - UTILS.getD3D(v9927.x, v9927.y, v9927.z, v9918.x, v9918.y, v9918.z) / 600);
          var v10028 = v10027 * 70;
          var v10029 = v10028 >= 1 && p12553.frustum.containPoint(v9918);
          var v9974 = vA550[v9892.team && game.mode && game.mode.teams && v9892.team == v9928 ? 0 : 1];
          if (v10029 && v9974 && v9974.isReady) {
            v9918.project(p12553.camera);
            v9918.x = (v9918.x + 1) / 2;
            v9918.y = (v9918.y + 1) / 2;
            var v10033 = v9918.x * v9923;
            var v10034 = (1 - v9918.y) * v9924;
            var v10035 = p12554 ? p12554.aimVal : 1;
            var v10036 = UTILS.inRange(v10033, v9923 * 0.45, v9923 * 0.55) && UTILS.inRange(v10034, v9924 * 0.4, v9924 * 0.6) && v10035 != 1;
            v9894.globalAlpha = v10036 ? vVO311.adsObjectiveOpacity : vVO311.objectiveOpacity;
            let v9979 = v10028 / v9974.width;
            v9894.save(1);
            v9894.translate(v10033, v10034);
            v9894.scale(v9979, v9979);
            v9894.drawImage(v9974, -v9974.width / 2, -v9974.height / 2);
            v9894.restore(-1);
          }
        }
      }
    }
  }
  if (v9926) {
    f1566(p12553, p12555, v9923, v9924, p12554, v9927);
  }
  if (v9926) {
    for (var vLN01620 = 0; vLN01620 < game.airDrop.drops.length; ++vLN01620) {
      v9892 = game.airDrop.drops[vLN01620];
      if (v9892.canClaim && !UTILS.pointInBox3D(v9927.x, v9927.y, v9927.z, v9892, 10)) {
        v9918.set(v9892.x, v9892.y + 13, v9892.z);
        var v10027 = Math.max(0.3, 1 - UTILS.getD3D(v9927.x, v9927.y, v9927.z, v9918.x, v9918.y, v9918.z) / 600);
        var v10028 = v10027 * 70;
        var v10029 = v10028 >= 1 && p12553.frustum.containPoint(v9918);
        var v10119 = vVO311.HELPER.loadImg(UTILS.assetsUrl("/img/streaks/package/" + (v9892.icon || 0) + ".png"));
        if (v10029 && v10119.isReady) {
          v9918.project(p12553.camera);
          v9918.x = (v9918.x + 1) / 2;
          v9918.y = (v9918.y + 1) / 2;
          let v9984 = v10028 / v10119.width;
          v9894.save(1);
          v9894.translate(v9918.x * v9923, (1 - v9918.y) * v9924);
          v9894.scale(v9984, v9984);
          if (v9892.animate) {
            v9894.filter = "hue-rotate(" + vVO311.rainbow.val + "deg)";
          }
          v9894.drawImage(v10119, -v10119.width / 2, -v10119.height / 2);
          v9894.restore(-1);
        }
      }
    }
  }
  if (v9926 && game.map.manager.pickups.length > 0) {
    for (var vLN01620 = 0; vLN01620 < game.map.manager.pickups.length; ++vLN01620) {
      v9892 = game.map.manager.pickups[vLN01620];
      if (v9892.active && v9892.showIcon && v9892.pickup != null && !UTILS.pointInBox3D(v9927.x, v9927.y, v9927.z, v9892, 0)) {
        v9918.set(v9892.x, v9892.y + 2, v9892.z);
        var v9993 = UTILS.getD3D(v9927.x, v9927.y, v9927.z, v9918.x, v9918.y, v9918.z);
        if (v9993 > config.pickupImgRange) {
          continue;
        }
        var v10027 = Math.max(0.3, 1 - v9993 / 600);
        var v10028 = v10027 * 120;
        var v10029 = v10028 >= 1 && p12553.frustum.containPoint(v9918);
        var v9989 = UTILS.assetsUrl((game.weaponConfig[v9892.pickup].melee ? "/textures/melee/icon_0" : "/textures/weapons/" + game.weaponConfig[v9892.pickup].icon) + ".png");
        if (game.weaponConfig[v9892.pickup].assetIcon.length) {
          v9989 = UTILS.userAssetsUrl("/" + game.weaponConfig[v9892.pickup].assetIcon.replace(/[^\d]/g, "") + "/texture.png");
        }
        var v10119 = vVO311.HELPER.loadImg(v9989);
        if (v10029 && v10119.isReady) {
          v9918.project(p12553.camera);
          v9918.x = (v9918.x + 1) / 2;
          v9918.y = (v9918.y + 1) / 2;
          let v9991 = v10028 / v10119.width;
          v9894.save(1);
          v9894.translate(v9918.x * v9923, (1 - v9918.y) * v9924);
          v9894.scale(v9991, v9991);
          if (v9892.animate) {
            v9894.filter = "hue-rotate(" + vVO311.rainbow.val + "deg)";
          }
          v9894.drawImage(v10119, -v10119.width / 2, -v10119.height / 2);
          v9894.restore(-1);
        }
      }
    }
  }
  if (v9926) {
    for (var v9992 in game.map.manager.spawnables) {
      v9892 = game.map.manager.spawnables[v9992];
      if (v9892 && v9892.active && medals[v9892.i] && medals[v9892.i].icon != null && !UTILS.pointInBox3D(v9927.x, v9927.y, v9927.z, v9892, 0)) {
        v9918.set(v9892.x, v9892.y + 2, v9892.z);
        var v9993 = UTILS.getD3D(v9927.x, v9927.y, v9927.z, v9918.x, v9918.y, v9918.z);
        if (v9993 > config.pickupImgRange) {
          continue;
        }
        var v10027 = Math.max(0.3, 1 - v9993 / 600);
        var v10028 = v10027 * 60;
        var v10029 = v10028 >= 1 && p12553.frustum.containPoint(v9918);
        var v10119 = vVO311.HELPER.loadImg(UTILS.assetsUrl("/img/medals/medal_" + medals[v9892.i].icon + ".png"));
        if (v10029 && v10119 && v10119.isReady) {
          v9918.project(p12553.camera);
          v9918.x = (v9918.x + 1) / 2;
          v9918.y = (v9918.y + 1) / 2;
          let v9998 = v10028 / v10119.width;
          v9894.save(1);
          v9894.translate(v9918.x * v9923, (1 - v9918.y) * v9924);
          v9894.scale(v9998, v9998);
          v9894.drawImage(v10119, -v10119.width / 2, -v10119.height / 2);
          v9894.restore(-1);
        }
      }
    }
  }
  if (game.mode && (game.mode.flags || game.mode.oneflag) && v9926 && game.map.manager.flags.length > 0) {
    for (var vLN01620 = 0; vLN01620 < game.map.manager.flags.length; ++vLN01620) {
      v9892 = game.map.manager.flags[vLN01620];
      if ((!game.mode.oneflag || v9892.neutral) && (game.mode.oneflag || !v9892.neutral) && !UTILS.pointInBox3D(v9927.x, v9927.y, v9927.z, v9892.img)) {
        v9918.set(v9892.img.x, v9892.img.y + 7, v9892.img.z);
        var v10027 = Math.max(0.3, 1 - UTILS.getD3D(v9927.x, v9927.y, v9927.z, v9918.x, v9918.y, v9918.z) / 600);
        var v10028 = v10027 * 70;
        var v10029 = v10028 >= 1 && p12553.frustum.containPoint(v9918);
        var v10002 = vA549[v9892.team == v9928 ? 1 : 0];
        if (v10029 && v10002 && v10002.isReady) {
          v9918.project(p12553.camera);
          v9918.x = (v9918.x + 1) / 2;
          v9918.y = (v9918.y + 1) / 2;
          var v10033 = v9918.x * v9923;
          var v10034 = (1 - v9918.y) * v9924;
          var v10035 = p12554 ? p12554.aimVal : 1;
          var v10036 = UTILS.inRange(v10033, v9923 * 0.45, v9923 * 0.55) && UTILS.inRange(v10034, v9924 * 0.4, v9924 * 0.6) && v10035 != 1;
          v9894.globalAlpha = v10036 ? vVO311.adsObjectiveOpacity : vVO311.objectiveOpacity;
          let v10007 = v10028 / v10002.width;
          v9894.save(1);
          v9894.translate(v10033, v10034);
          v9894.scale(v10007, v10007);
          v9894.drawImage(v10002, -v10002.width / 2, -v10002.height / 2);
          v9894.restore(-1);
        }
      }
    }
  }
  if (game.mode && game.mode.objective && v9926 && game.map.manager.objectives.length > 0) {
    var v10008 = game.activeObjective;
    var v10009 = game.map.manager.objectives.find(p12558 => p12558 && p12558.uid == v10008 + 1);
    var v10010 = v10009 ? v10009.uid : 0;
    var v10011 = !game.mode.deposit && game.objtvTime <= 15000 && game.gameTimer - game.objtvTime >= 5000;
    for (var vLN01620 = 0; vLN01620 < game.map.manager.objectives.length; ++vLN01620) {
      v9892 = game.map.manager.objectives[vLN01620];
      if (v9892 && (v9892.uid != v10008 || UTILS.pointInBox3D(v9927.x, v9927.y, v9927.z, v9892) ? v10011 && v9892.uid == v10010 && !UTILS.pointInBox3D(v9927.x, v9927.y, v9927.z, v9892) && f1565(p12553, game, v9923, v9924, p12554, v9892, v9927, true) : f1565(p12553, game, v9923, v9924, p12554, v9892, v9927), v9892.uid == v10008 && p12554 && p12554.onZone == v9892.uid && v9892.onZone > 1)) {
        v9894.save(1);
        v9894.beginPath();
        v9894.translate(UTILS.calcPercent(v9923, vVO311.captureProg.left), UTILS.isNumber(vVO311.captureProg.top) ? UTILS.calcPercent(v9924, vVO311.captureProg.top) : +vVO311.captureProg.top.replace("px", ""));
        if (vVO311.captureProg.rot) {
          v9894.rotate(vVO311.captureProg.rot);
        }
        v9894.fillStyle = vVO311.captureProg.color;
        v9894.font = "20px GameFont";
        var v10047 = "CONTESTED";
        var v10051 = v9894.measureText(v10047).width;
        v9894.fillStyle = "#333";
        v9894.globalAlpha = 0.8;
        v9894.fillRect(0 - (v10051 + 50) / 2, -57.5, v10051 + 50, 50);
        v9894.globalAlpha = 1;
        v9894.textAlign = "center";
        v9894.fillStyle = vVO311.captureProg.color;
        v9894.fillText(v10047, 0, -20);
        v9894.closePath();
        v9894.restore(-1);
      }
    }
  }
  if (game.mode && game.mode.site && v9926 && game.map.manager.sites.length > 0) {
    for (var vLN01620 = 0; vLN01620 < game.map.manager.sites.length; ++vLN01620) {
      v9892 = game.map.manager.sites[vLN01620];
      if (!UTILS.pointInBox3D(v9927.x, v9927.y, v9927.z, v9892)) {
        v9918.set(v9892.x, v9892.y + 7, v9892.z);
        var v10027 = Math.max(0.3, 1 - UTILS.getD3D(v9927.x, v9927.y, v9927.z, v9918.x, v9918.y, v9918.z) / 600);
        var v10028 = v10027 * 40;
        var v10029 = v10028 >= 1 && p12553.frustum.containPoint(v9918);
        var v10030 = String.fromCharCode(65 + vLN01620);
        if (v10029) {
          v9918.project(p12553.camera);
          v9918.x = (v9918.x + 1) / 2;
          v9918.y = (v9918.y + 1) / 2;
          var v10033 = v9918.x * v9923;
          var v10034 = (1 - v9918.y) * v9924;
          var v10035 = p12554 ? p12554.aimVal : 1;
          var v10036 = UTILS.inRange(v10033, v9923 * 0.45, v9923 * 0.55) && UTILS.inRange(v10034, v9924 * 0.4, v9924 * 0.6) && v10035 != 1;
          v9894.globalAlpha = v10036 ? vVO311.adsObjectiveOpacity : vVO311.objectiveOpacity;
          let v10021 = v10028 / 50;
          v9894.save(1);
          v9894.translate(v10033, v10034);
          v9894.scale(v10021, v10021);
          v9894.fillStyle = "#FBC02D";
          v9894.font = "50px GameFont";
          v9894.strokeStyle = "#2e2e2e";
          v9894.lineWidth = 4;
          v9894.strokeText(v10030, -24, -25);
          v9894.fillText(v10030, -25, -25);
          v9894.restore(-1);
        }
      }
    }
    for (var vLN01620 = 0; vLN01620 < game.map.manager.pickups.length; ++vLN01620) {
      v9892 = game.map.manager.pickups[vLN01620];
      if (v9928 == 2 && v9892.pickup == 17 && !UTILS.pointInBox3D(v9927.x, v9927.y, v9927.z, v9892)) {
        v9918.set(v9892.x, v9892.y + 4, v9892.z);
        var v10027 = Math.max(0.3, 1 - UTILS.getD3D(v9927.x, v9927.y, v9927.z, v9918.x, v9918.y, v9918.z) / 600);
        var v10028 = v10027 * 40;
        var v10029 = v10028 >= 1 && p12553.frustum.containPoint(v9918);
        if (v10029 && v9896 && v9896.isReady) {
          v9918.project(p12553.camera);
          v9918.x = (v9918.x + 1) / 2;
          v9918.y = (v9918.y + 1) / 2;
          let v10025 = v10028 / v9896.width;
          v9894.save(1);
          v9894.translate(v9918.x * v9923, (1 - v9918.y) * v9924);
          v9894.scale(v10025, v10025);
          var vLN352 = 50;
          var vLN40 = 40;
          var v10046 = config.alphabet[game.activeObjective || 0] || "";
          v9894.fillStyle = "#fff";
          v9894.font = vLN352 + "px GameFont";
          v9894.fillText(v10046, -vLN352 / 2, -vLN352 / 2 - vLN40);
          v9894.drawImage(v9896, -v9896.width / 2, -v9896.height / 2);
          v9894.restore(-1);
        }
      }
    }
  }
  if (game.mode && game.mode.dom && v9926 && game.map.manager.domzones.length > 0) {
    for (var vLN01620 = 0; vLN01620 < game.map.manager.domzones.length; ++vLN01620) {
      v9892 = game.map.manager.domzones[vLN01620];
      if (v9892) {
        if (!UTILS.pointInBox3D(v9927.x, v9927.y, v9927.z, v9892)) {
          v9918.set(v9892.x, v9892.y + 7, v9892.z);
          var v10027 = Math.max(0.3, 1 - UTILS.getD3D(v9927.x, v9927.y, v9927.z, v9918.x, v9918.y, v9918.z) / 600);
          v9918.set(v9892.x, v9892.y + 7, v9892.z);
          var v10028 = v10027 * 70;
          var v10029 = v10028 >= 1 && p12553.frustum.containPoint(v9918);
          var v10030 = String.fromCharCode(65 + (v9892.uid || 0));
          var v10031 = v9892.capturedBy == null ? "#dbdbdb" : v9892.capturedBy == v9928 ? "#5699EB" : "#eb5656";
          var v10032 = v9892.lastTeamOn == v9928 ? "#5699EB" : "#eb5656";
          if (v10029) {
            v9918.project(p12553.camera);
            v9918.x = (v9918.x + 1) / 2;
            v9918.y = (v9918.y + 1) / 2;
            var v10033 = v9918.x * v9923;
            var v10034 = (1 - v9918.y) * v9924;
            var v10035 = p12554 ? p12554.aimVal : 1;
            var v10036 = UTILS.inRange(v10033, v9923 * 0.45, v9923 * 0.55) && UTILS.inRange(v10034, v9924 * 0.4, v9924 * 0.6) && v10035 != 1;
            v9894.globalAlpha = v10036 ? vVO311.adsObjectiveOpacity : vVO311.objectiveOpacity;
            let v10037 = v10028 / 128;
            v9894.save(1);
            v9894.translate(v10033, v10034);
            v9894.scale(v10037, v10037);
            var vLN352 = 50;
            var v10038 = vLN352 * 1.25;
            v9894.beginPath();
            v9894.arc(-vLN352 / 10, -vLN352 - vLN352 / 10, v10038, 0, Math.PI * 2, false);
            v9894.fillStyle = v10031;
            v9894.fill();
            v9894.closePath();
            v9894.fillStyle = "#fff";
            v9894.font = vLN352 + "px GameFont";
            v9894.strokeStyle = "#2e2e2e";
            v9894.lineWidth = 4;
            v9894.strokeText(v10030, -vLN352 / 2 + 1, -vLN352 / 2);
            v9894.fillText(v10030, -vLN352 / 2, -vLN352 / 2);
            var v10047 = v9892.capturedBy == v9928 ? v9892.capturedBy == v9928 && v9892.captureT > 0 ? "LOSING" : "DEFEND" : v9892.capturedBy != v9928 && v9892.captureT > 0 && v9892.lastTeamOn == v9928 ? "SECURING" : "SECURE";
            v9894.font = vLN352 / 2 + "px GameFont";
            v9894.fillStyle = "#333";
            v9894.globalAlpha = (v10036 ? vVO311.adsObjectiveOpacity : vVO311.objectiveOpacity) * 0.8;
            var v10051 = v9894.measureText(v10047).width;
            v9894.fillRect(0 - (v10051 + 50) / 2, -(170 + vLN352 / 2), v10051 + 50, vLN352 / 2 + 30);
            v9894.fillStyle = "#fff";
            v9894.strokeStyle = "#2e2e2e";
            v9894.lineWidth = 4;
            v9894.textAlign = "center";
            v9894.strokeText(v10047, 1, -150);
            v9894.fillText(v10047, 0, -150);
            if (v9892.captureT > 0) {
              v9894.globalAlpha = v10036 ? vVO311.adsObjectiveOpacity : vVO311.objectiveOpacity;
              let v10041 = v9892.captureT / game.mode.captureTime;
              v9894.lineWidth = 10;
              v9894.strokeStyle = v10032;
              v9894.beginPath();
              v9894.translate(-vLN352 / 10, -vLN352 - vLN352 / 10);
              v9894.rotate(-Math.PI / 2);
              v9894.translate(-(-vLN352 / 10), -(-vLN352 - vLN352 / 10));
              v9894.arc(-vLN352 / 10, -vLN352 - vLN352 / 10, v10038 + 5, Math.PI * 2 * v10041, 0, true);
              v9894.stroke();
              v9894.closePath();
            }
            v9894.restore(-1);
          }
        }
        if (v9892.captureT > 0 && p12554 && p12554.onZone == v9892.uid) {
          v9892.needsUpdate = false;
          let v10042 = v9892.lastTeamOn == v9928 && v9892.capturedBy != v9928;
          let v10043 = v9892.captureT / game.mode.captureTime;
          let v10044 = vVO311.captureProg.width * vVO311.captureProg.scale;
          let v10045 = vVO311.captureProg.height * vVO311.captureProg.scale;
          v9894.save(1);
          v9894.beginPath();
          v9894.translate(UTILS.calcPercent(v9923, vVO311.captureProg.left), UTILS.isNumber(vVO311.captureProg.top) ? UTILS.calcPercent(v9924, vVO311.captureProg.top) : +vVO311.captureProg.top.replace("px", ""));
          if (vVO311.captureProg.rot) {
            v9894.rotate(vVO311.captureProg.rot);
          }
          v9894.fillStyle = vVO311.captureProg.color;
          v9894.font = "20px GameFont";
          var v10046 = config.alphabet[v9892.uid || 0] || "";
          var v10047 = (v10042 ? "SECURING" : "CONTESTING") + " " + v10046;
          var v10051 = v9894.measureText(v10047).width;
          v9894.fillStyle = "#333";
          v9894.globalAlpha = 0.8;
          v9894.fillRect(0 - (v10051 + 50) / 2, -57.5, v10051 + 50, 50);
          v9894.globalAlpha = 1;
          v9894.textAlign = "center";
          v9894.fillStyle = vVO311.captureProg.color;
          v9894.fillText(v10047, 0, -20);
          v9894.globalAlpha = vVO311.captureProg.opacity;
          v9894.fillStyle = "rgba(0, 0, 0, 0.4)";
          if (vVO311.captureProg.shadow) {
            v9894.strokeStyle = "#000000";
          }
          v9894.roundRect(0 - v10044 / 2, 0, v10044, v10045, 4, true, vVO311.captureProg.shadow);
          v9894.strokeStyle = null;
          v9894.fillStyle = v10042 ? vVO311.captureProg.color : "#eb5656";
          v9894.roundRect(0 - v10044 / 2, 0, v10044 * v10043, v10045, 2, true, vVO311.captureProg.shadow);
          v9894.closePath();
          v9894.restore(-1);
        }
      }
    }
  }
  if (p12554 && p12554.active && p12554.isKranked && p12554.krankedTimer > 0) {
    p12554.krankedTimer -= p12555;
    p12554.krankedTick -= p12555;
    if (p12554.krankedTick <= 0) {
      var vLN10004 = 1000;
      if (p12554.krankedTimer <= 2000) {
        vLN10004 = 250;
      } else if (p12554.krankedTimer <= 5000) {
        vLN10004 = 500;
      }
      p12554.krankedTick = vLN10004;
      SOUND.play("beep_0", 0.1, false, UTILS.randFloat(0.95, 1));
    }
    if (v9926 && p12554.krankedTimer > 0) {
      var vLN352 = 35;
      v9894.save(1);
      v9894.beginPath();
      v9894.translate(UTILS.calcPercent(v9923, 50), UTILS.calcPercent(v9924, 80));
      v9894.font = vLN352 + "px GameFont";
      var v10049 = UTILS.getChargedTime(p12554.krankedTimer);
      var v10050 = v9894.measureText(v10049).width;
      var vLSKranked = "Kranked! ";
      var v10051 = v9894.measureText(vLSKranked).width;
      var v10052 = v10051 + v10050;
      v9894.fillStyle = "rgba(0, 0, 0, 0.6)";
      v9894.roundRect(-(v10052 / 2) - 40, -80, v10052 + 80, 80, 4, true);
      v9894.fillStyle = "#fff";
      v9894.strokeStyle = "#2e2e2e";
      v9894.lineWidth = 4;
      v9894.strokeText(vLSKranked, -(v10052 / 2) + 1, -vLN352 / 2);
      v9894.fillText(vLSKranked, -(v10052 / 2), -vLN352 / 2);
      v9894.fillStyle = p12554.krankedTimer < 5000 ? "#eb5656" : p12554.krankedTimer < 8500 ? "#FBC02D" : "#76ff03";
      v9894.strokeStyle = "#2e2e2e";
      v9894.lineWidth = 4;
      v9894.strokeText(v10049, -(v10052 / 2) + v10051 + 1, -vLN352 / 2);
      v9894.fillText(v10049, -(v10052 / 2) + v10051, -vLN352 / 2);
      v9894.closePath();
      v9894.restore(-1);
    }
  }
  if (v9926) {
    f1560(v9894, v9923, v9924, p12555, game, p12554);
  }
  if (game.controls.camType.isNormal || p12554 && p12554.config.shtToCam) {
    if (vVO311.showFlash && v9895 && v9895.isReady) {
      let v10053 = v9923 * 1.6;
      v9894.drawImage(v9895, v9923 * vVO311.flashX - v10053 / 2, v9924 * vVO311.flashY - v10053 / 2, v10053, v10053);
    }
    if (v9926) {
      var v10054 = centerLeaderDisplay.style.display !== "inline-grid" && !vVO311.disableCrosshair;
      if (v10054 && p12554 && p12554.active && p12554.config.shtDrg != 1) {
        var vLN10005 = 1000;
        var v10055 = p12554.xDirChase || 0;
        var v10056 = p12554.yDirChase || 0;
        v9918.set(p12554.x + vLN10005 * Math.sin(v10055 + Math.PI) * Math.cos(v10056), p12554.y + p12554.height + vLN10005 * Math.sin(v10056), p12554.z + vLN10005 * Math.cos(v10055 + Math.PI) * Math.cos(v10056));
        if (p12553.frustum.containPoint(v9918)) {
          v9918.project(p12553.camera);
          v9918.x = (v9918.x + 1) / 2;
          v9918.y = (v9918.y + 1) / 2;
          var v10057 = Math.round(v9923 * v9918.x);
          var v10058 = Math.round(v9924 * (1 - v9918.y));
          v9894.save(1);
          v9894.translate(v10057, v10058);
          if (vVO311.mapCrossChase) {
            var v10119 = vVO311.HELPER.loadImg(UTILS.userAssetsUrl(vVO311.mapCrossChase + "/texture.png"));
            if (v10119.isReady) {
              v9894.beginPath();
              v9894.drawImage(v10119, -(v10119.width / 2), -(v10119.height / 2));
            }
          } else {
            v9894.strokeStyle = "#000000";
            v9894.lineWidth = 5;
            v9894.beginPath();
            v9894.arc(0, 0, 20, 0, Math.PI * 2);
            v9894.stroke();
            v9894.strokeStyle = "#ffffff";
            v9894.lineWidth = 3;
            v9894.beginPath();
            v9894.arc(0, 0, 20, 0, Math.PI * 2);
            v9894.stroke();
          }
          v9894.restore(-1);
        }
      }
      if (vVO311.fakeCross) {
        if (v10054 && aimRecticle.style.opacity != 1 && p12553.aimRecticle.opacity != 1) {
          v9894.save(1);
          v9894.translate(v9923 / 2, v9924 / 2);
          f1571(v9894, 2, 4, 1, 1, 90);
          f1571(v9894, 2, 4, 1, 1, -90);
          f1571(v9894, 2, 4, 1, 1, 0);
          f1571(v9894, 2, 4, 1, 1, 180);
          v9894.restore(-1);
        }
      } else if (!window.spectating && v10054) {
        let v10060 = v9923 / 2;
        let v10061 = v9924 / 2;
        if (p12554 && p12554.aimVal == 0 && p12554.canThrow && p12554.weapon.canThrow) {
          let v10062 = vVO311.crosshairThickM;
          let v10063 = vVO311.crosshairLenM;
          let vLN1144 = 1;
          if (vVO311.crosshairTypeM > 0 && vVO311.crosshairAlwaysM) {
            vLN1144 = 1;
          }
          if (vVO311.crosshairTypeM > 0 && vVO311.crosshairUseOpacityCustomM) {
            vLN1144 = vVO311.crosshairOpacityCustomM;
          }
          if (vLN1144) {
            v9894.save(1);
            v9894.globalAlpha = vLN1144;
            if (vVO311.crosshairTypeM == 1) {
              if (vVO311.crosshairStyleM == 0) {
                f1567(v9894, v10060 - v10062 * 0.5, v10061 - v10063, v10062, v10063 * 2, 1, false, vVO311.crosshairShadowThicknessM);
                f1567(v9894, v10060 - v10063, v10061 - v10062 / 2, v10063 * 2, v10062, 1, false, vVO311.crosshairShadowThicknessM);
                f1567(v9894, v10060 - v10062 * 0.5, v10061 - v10063, v10062, v10063 * 2, 1, false, false);
              } else if (vVO311.crosshairStyleM > 0) {
                f1567(v9894, v10060 - v10063 * 2 / 2, v10061 - v10063 * 2 / 2, v10063 * 2, v10063 * 2, v10062 / 2, vVO311.crosshairStyleM == 1 || vVO311.crosshairStyleM == 2, vVO311.crosshairShadowThicknessM, vVO311.crosshairStyleM == 2 || vVO311.crosshairStyleM == 4);
              }
            } else if (vVO311.crosshairTypeM == 2) {
              v9894.translate(0, 0);
              v9894.beginPath();
              var v10072 = vVO311.crosshairImageWM || vVO311.crosshairImageM.width;
              var v10073 = vVO311.crosshairImageHM || vVO311.crosshairImageM.height;
              var v10074 = vVO311.crosshairImageM ? vVO311.crosshairImageM.lastFrame && vVO311.crosshairImageM.lastFrame.image ? vVO311.crosshairImageM.lastFrame.image : vVO311.crosshairImageM.image ? vVO311.crosshairImageM.image : vVO311.crosshairImageM : null;
              if (vVO311.crosshairImageM && vVO311.crosshairImageM.isReady && v10074) {
                v9894.drawImage(v10074, v10060 - v10072 / 2, v10061 - v10073 / 2, v10072, v10073);
              }
            } else if (vVO311.crosshairTypeM == 3) {
              v9894.translate(v10060, v10061);
              f1572(v9894, v10062, null, null, vVO311.crosshairShadowThicknessM, null, true);
              f1572(v9894, v10062, v10063 * 0.8, vVO311.crosshairGapM, vVO311.crosshairShadowThicknessM, 90);
              f1572(v9894, v10062, v10063 * 0.8, vVO311.crosshairGapM, vVO311.crosshairShadowThicknessM, -90);
              f1572(v9894, v10062, v10063 * 1.5, vVO311.crosshairGapM, vVO311.crosshairShadowThicknessM, 0);
              f1572(v9894, v10062, v10063 * 1.5, vVO311.crosshairGapM + 1, vVO311.crosshairShadowThicknessM, 180);
            }
            v9894.restore(-1);
          }
        } else if (vVO311.crosshairType > 0) {
          let v10067 = vVO311.crosshairScale;
          let vLN414 = 4;
          let vLN21 = 21;
          let v10068 = vVO311.crosshairThick;
          let v10069 = vVO311.crosshairLen;
          let v10070 = vVO311.crosshairOpacity;
          if (vVO311.crosshairType > 1 && vVO311.crosshairAlways) {
            v10070 = 1;
          }
          if (vVO311.crosshairType > 1 && vVO311.crosshairUseOpacityCustom) {
            v10070 = vVO311.crosshairOpacityCustom;
          }
          if (v10070) {
            v9894.save(1);
            v9894.globalAlpha = v10070;
            if (vVO311.mapCross) {
              var v10119 = vVO311.HELPER.loadImg(UTILS.userAssetsUrl(vVO311.mapCross + "/texture.png"));
              if (v10119.isReady) {
                v9894.translate(0, 0);
                v9894.beginPath();
                v9894.drawImage(v10119, v10060 - v10119.width / 2, v10061 - v10119.height / 2);
              }
            } else {
              if (vVO311.crosshairType == 4) {
                v9894.translate(0, 0);
                v9894.beginPath();
                var v10072 = vVO311.crosshairImageW || vVO311.crosshairImage.width;
                var v10073 = vVO311.crosshairImageH || vVO311.crosshairImage.height;
                var v10074 = vVO311.crosshairImage ? vVO311.crosshairImage.lastFrame && vVO311.crosshairImage.lastFrame.image ? vVO311.crosshairImage.lastFrame.image : vVO311.crosshairImage.image ? vVO311.crosshairImage.image : vVO311.crosshairImage : null;
                if (vVO311.crosshairImage && vVO311.crosshairImage.isReady && v10074) {
                  v9894.drawImage(v10074, v10060 - v10072 / 2, v10061 - v10073 / 2, v10072, v10073);
                }
              } else if (vVO311.crosshairType == 2 || vVO311.crosshairType == 3) {
                if (vVO311.crosshairStyle == 0) {
                  f1567(v9894, v10060 - v10068 * 0.5, v10061 - v10069, v10068, v10069 * 2, 1, false, vVO311.crosshairShadowThickness);
                  f1567(v9894, v10060 - v10069, v10061 - v10068 / 2, v10069 * 2, v10068, 1, false, vVO311.crosshairShadowThickness);
                  f1567(v9894, v10060 - v10068 * 0.5, v10061 - v10069, v10068, v10069 * 2, 1, false, false);
                } else if (vVO311.crosshairStyle > 0) {
                  f1567(v9894, v10060 - v10069 * 2 / 2, v10061 - v10069 * 2 / 2, v10069 * 2, v10069 * 2, v10068 / 2, vVO311.crosshairStyle == 1 || vVO311.crosshairStyle == 2, vVO311.crosshairShadowThickness, vVO311.crosshairStyle == 2 || vVO311.crosshairStyle == 4);
                }
              } else if (vVO311.crosshairType == 5) {
                v9894.translate(v10060, v10061);
                if (vVO311.crosshairDot) {
                  f1571(v9894, v10068, null, null, null, null, true);
                }
                f1571(v9894, v10068, v10069, vVO311.crosshairGap, vVO311.crosshairShadowThickness, 90);
                f1571(v9894, v10068, v10069, vVO311.crosshairGap, vVO311.crosshairShadowThickness, -90);
                f1571(v9894, v10068, v10069, vVO311.crosshairGap, vVO311.crosshairShadowThickness, 0);
                f1571(v9894, v10068, v10069, vVO311.crosshairGap, vVO311.crosshairShadowThickness, 180);
              }
              if (vVO311.crosshairType == 1 || vVO311.crosshairType == 3) {
                v9894.globalAlpha = vVO311.crosshairOpacity;
                v9894.translate(v10060, v10061);
                var v10075 = v10067 / 2 - vLN414 / 2;
                if (vVO311.crosshairDot) {
                  f1571(v9894, vLN414 + 2, null, null, vVO311.crosshairShadowThickness, null, true, true);
                }
                f1571(v9894, vLN414 + 2, vLN21 + 2, v10075, vVO311.crosshairShadowThickness, 90, false, true);
                f1571(v9894, vLN414 + 2, vLN21 + 2, v10075, vVO311.crosshairShadowThickness, -90, false, true);
                f1571(v9894, vLN414 + 2, vLN21 + 2, v10075, vVO311.crosshairShadowThickness, 0, false, true);
                f1571(v9894, vLN414 + 2, vLN21 + 2, v10075, vVO311.crosshairShadowThickness, 180, false, true);
              }
            }
            v9894.restore(-1);
          } else if (p12554 && p12554.weapon.build && !p12554.selectBuild) {
            v9894.save(1);
            v9894.translate(v10060, v10061);
            f1571(v9894, 3, null, null, vVO311.crosshairShadowThickness, null, true);
            f1571(v9894, 3, v10069 * 0.5, 12, vVO311.crosshairShadowThickness, 90);
            f1571(v9894, 3, v10069 * 0.5, 12, vVO311.crosshairShadowThickness, -90);
            f1571(v9894, 3, v10069 * 0.5, 12, vVO311.crosshairShadowThickness, 0);
            f1571(v9894, 3, v10069 * 0.5, 12, vVO311.crosshairShadowThickness, 180);
            v9894.restore(-1);
          }
        }
      }
    }
  }
  if (p12554 && p12554.selectBuild && !v9929) {
    v9894.save(1);
    v9894.translate(v9923 / 2, v9924 / 2);
    var v10111 = v9924 / 2 * 0.4;
    v9894.globalAlpha = 0.7;
    v9894.beginPath();
    v9894.arc(0, 0, v10111, 0, Math.PI * 2, false);
    v9894.fillStyle = "#171717";
    v9894.fill();
    var v10112 = v10111 * 1.33;
    var v10113 = v10111 / 1.9;
    v9894.globalAlpha = 1;
    v9894.lineWidth = v10113;
    v9894.strokeStyle = "#cfcfcf";
    v9894.beginPath();
    v9894.arc(0, 0, v10112, 0, Math.PI * 2, false);
    v9894.stroke();
    var v10115 = game.BUILD_OBJS[p12554.buildIndex];
    var v10116 = Math.PI * 2 / game.BUILD_OBJS.length;
    var v10117 = v10116 * p12554.buildIndex;
    v9894.strokeStyle = "#55acee";
    v9894.beginPath();
    v9894.arc(0, 0, v10112, v10117, v10117 + v10116, false);
    v9894.stroke();
    var vLN507 = 50;
    var vLN404 = 40;
    var v10118 = v10115.name;
    v9894.fillStyle = "#dbdbdb";
    v9894.font = vLN404 + "px GameFont";
    v9894.fillText(v10118, -v9894.measureText(v10118).width / 2, vLN404 / 2 + vLN507);
    vLN404 = 25;
    v10118 = v10115.cost + " Score";
    v9894.fillStyle = p12554.score >= v10115.cost ? "#a3a3a3" : "#d63e3e";
    v9894.font = vLN404 + "px GameFont";
    v9894.fillText(v10118, -v9894.measureText(v10118).width / 2, vLN404 / 2 + vLN507 + 50);
    var v10119 = vVO311.HELPER.loadImg(UTILS.assetsUrl("/img/build/build_" + v10115.icon + ".png"));
    v9894.drawImage(v10119, -50, -50 - vLN507 * 1.5, 100, 100);
    var v10121 = -(v10116 / 2);
    for (var vLN01620 = 0; vLN01620 < game.BUILD_OBJS.length; ++vLN01620) {
      v10121 += v10116;
      v10119 = vVO311.HELPER.loadImg(UTILS.assetsUrl("/img/build/build_" + game.BUILD_OBJS[vLN01620].icon + ".png"));
      if (v10119.isReady) {
        v9894.drawImage(v10119, v10112 * Math.cos(v10121) - 40, v10112 * Math.sin(v10121) - 40, 80, 80);
      }
    }
    v9894.restore(-1);
  }
  if (v9926) {
    vVO311.HELPER.updateCustomGUI(v9894, v9923, v9924, p12554, game, config, vVO311.customGUIs, true, p12552.mouseX / p12550, p12552.mouseY / p12550);
    for (var vLN01620 = 0; vLN01620 < vVO311.divsToUpd.length; vLN01620++) {
      var v10085 = vVO311.divsToUpd[vLN01620];
      var v10086 = v10085.curr;
      if (v10085.data.vt == 0) {
        v10086 = v10085.data.v || "Text";
      } else if (v10085.data.vt == 1) {
        if (p12554) {
          if (config.playerVals.indexOf(v10085.data.v) > -1) {
            v10086 = p12554[v10085.data.v];
          } else {
            v10086 = p12554.custVals[v10085.data.v] || 0;
          }
        }
      } else if (v10085.data.vt == 2 && game && game.globalVals[v10085.data.v + ""] != null) {
        v10086 = game.globalVals[v10085.data.v + ""];
      }
      if (v10085.curr != v10086) {
        v10085.curr = v10086;
        v10085.elm.innerHTML = v10085.curr;
        v10085.elm.setAttribute("data-text", v10085.curr);
      }
    }
  }
  if (!vVO311.bloodCustom && vVO311.bloodOpacity > 0 && vVO311.bloodImage && vVO311.bloodImage.isReady && !v9925) {
    v9894.save(1);
    v9894.globalAlpha = vVO311.bloodOpacity;
    v9894.drawImage(vVO311.bloodImage, 0, 0, v9923, v9924);
    v9894.restore(-1);
  }
  if (v9929) {
    v9894.save(1);
    if (vVO311.scopeBorders.display && vVO311.scopeBorders.opacity > 0) {
      v9894.beginPath();
      v9894.globalAlpha = vVO311.scopeBorders.opacity;
      v9894.fillStyle = vVO311.scopeBorders.color;
      v9894.rect(0, 0, v9923, v9924 / 2 - p12553.aimRecticle.height / 2 + 2);
      v9894.rect(0, v9924 / 2 + p12553.aimRecticle.height / 2 - 2, v9923, v9924 - v9924 / 2 + p12553.aimRecticle.height / 2 + 2);
      v9894.rect(0, 0, v9923 / 2 - p12553.aimRecticle.width / 2 + 2, v9924);
      v9894.rect(v9923 / 2 + p12553.aimRecticle.width / 2 - 2, 0, v9923 - (v9923 / 2 + p12553.aimRecticle.width / 2) + 2, v9924);
      v9894.fill();
    }
    v9894.globalAlpha = p12553.aimRecticle.opacity * p12553.aimRecticle.opacMlt;
    v9894.drawImage(p12553.aimRecticle.image, v9923 / 2 - p12553.aimRecticle.width / 2, v9924 / 2 - p12553.aimRecticle.height / 2, p12553.aimRecticle.width, p12553.aimRecticle.height);
    v9894.restore(-1);
  }
  if (!p12553.aimDot.custom && p12553.aimDot.display && p12553.aimDot.opacity > 0 && p12553.aimDot.image && p12553.aimDot.image.isReady) {
    v9894.save(1);
    v9894.globalAlpha = 1;
    v9894.drawImage(p12553.aimDot.image, v9923 / 2 - p12553.aimDot.width / 2, v9924 / 2 - p12553.aimDot.height / 2, p12553.aimDot.width, p12553.aimDot.height);
    v9894.restore(-1);
  }
  f1558(v9894, v9923, v9924, p12555);
  if (v9926) {
    if (vVO311.interactProg.display) {
      let v10087 = vVO311.interactProg.prog;
      let v10088 = vVO311.interactProg.width * vVO311.interactProg.scale;
      let v10089 = vVO311.interactProg.height * vVO311.interactProg.scale;
      v9894.save(1);
      v9894.beginPath();
      v9894.translate(UTILS.calcPercent(v9923, vVO311.interactProg.left), UTILS.isNumber(vVO311.interactProg.top) ? UTILS.calcPercent(v9924, vVO311.interactProg.top) : +vVO311.interactProg.top.replace("px", ""));
      if (vVO311.interactProg.rot) {
        v9894.rotate(vVO311.interactProg.rot);
      }
      v9894.globalAlpha = vVO311.interactProg.opacity;
      v9894.fillStyle = "rgba(0, 0, 0, 0.4)";
      if (vVO311.interactProg.shadow) {
        v9894.strokeStyle = "#000000";
      }
      v9894.roundRect(0 - v10088 / 2, 0, v10088, v10089, 4, true, vVO311.interactProg.shadow);
      v9894.strokeStyle = null;
      v9894.fillStyle = vVO311.interactProg.color;
      v9894.roundRect(0 - v10088 / 2, 0, v10088 * v10087, v10089, 2, true, vVO311.interactProg.shadow);
      v9894.closePath();
      v9894.restore(-1);
    }
    if (vVO311.interactMProg.display) {
      let v10090 = vVO311.interactMProg.prog;
      let v10091 = vVO311.interactMProg.width * vVO311.interactMProg.scale;
      let v10092 = vVO311.interactMProg.height * vVO311.interactMProg.scale;
      v9894.save(1);
      v9894.beginPath();
      var vLN01616 = 0;
      if (v10090 > 1) {
        var v10093 = (v10090 - 1) / (1 - config.overCharge) * 300;
        vLN01616 = Math.sin((v10090 - 1) * v10093) * 8;
        v10092 *= 1 + (v10090 - 1) * 2;
      }
      v9894.translate(UTILS.calcPercent(v9923, vVO311.interactMProg.left) + vLN01616, UTILS.isNumber(vVO311.interactMProg.top) ? UTILS.calcPercent(v9924, vVO311.interactMProg.top) : +vVO311.interactMProg.top.replace("px", ""));
      if (vVO311.interactMProg.rot) {
        v9894.rotate(vVO311.interactMProg.rot);
      }
      v9894.globalAlpha = vVO311.interactMProg.opacity;
      var v10094 = p12554 && p12554.overCharged;
      v9894.fillStyle = "rgba(0, 0, 0, 0.4)";
      if (vVO311.interactMProg.shadow) {
        v9894.strokeStyle = "#000000";
      }
      v9894.roundRect(0 - v10091 / 2, 0, v10091, v10092, 4, true, vVO311.interactMProg.shadow);
      if (!v10094) {
        v9894.strokeStyle = null;
        v9894.fillStyle = vVO311.interactMProg.color;
        if (v10090 > 1) {
          v9894.fillStyle = vVO311.interactMProg.oColor;
        }
        v9894.roundRect(0 - v10091 / 2, 0, v10091 * Math.min(1, v10090), v10092, 2, true, vVO311.interactMProg.shadow);
      }
      v9894.closePath();
      if (v10094) {
        v9894.translate(0, v10092 / 2);
        for (var vLN01617 = 0; vLN01617 < 2; ++vLN01617) {
          v9894.strokeStyle = vLN01617 ? vVO311.interactMProg.oColor : "#000";
          v9894.lineWidth = vLN01617 ? 10 : 14;
          var v10095 = vLN01617 ? 28 : 30;
          v9894.beginPath();
          v9894.moveTo(-v10095, -v10095);
          v9894.lineTo(v10095, v10095);
          v9894.stroke();
          v9894.fill();
          v9894.moveTo(v10095, -v10095);
          v9894.lineTo(-v10095, v10095);
          v9894.stroke();
          v9894.fill();
        }
      }
      v9894.restore(-1);
    }
  }
  for (var vLN01620 = vVO311.divs.length - 1; vLN01620 >= 0; --vLN01620) {
    v9892 = vVO311.divs[vLN01620];
    if (v9892.life >= 0 && v9892.display && !v9892.disabled && v9926) {
      v9894.save(1);
      v9894.globalAlpha = v9892.opacity;
      if (v9892.text) {
        v9894.translate(UTILS.calcPercent(v9923, v9892.left), UTILS.isNumber(v9892.top) ? UTILS.calcPercent(v9924, v9892.top) : +v9892.top.replace("px", ""));
        if (v9892.rect) {
          v9894.fillStyle = v9892.rect.color;
          v9894.fillRect(0 - v9892.width / 2, v9892.rect.yOff || 0, v9892.width, v9892.height);
        }
        v9894.font = v9892.fontSize + "px GameFont";
        v9894.textBaseline = "middle";
        if (v9892.textAlign) {
          v9894.textAlign = v9892.textAlign;
        }
        if (v9892.shadow) {
          v9894.strokeStyle = "#363636";
          v9894.lineWidth = v9892.shadow;
          v9894.strokeText(v9892.text, 1, 0 + (v9892.lineHeight ? v9892.lineHeight / 2 : 0));
        }
        v9894.fillStyle = v9892.color;
        v9894.fillText(v9892.text, 0, 0 + (v9892.lineHeight ? v9892.lineHeight / 2 : 0));
        if (v9892.text2) {
          v9894.font = "34px GameFont";
          v9894.textBaseline = "middle";
          if (v9892.textAlign) {
            v9894.textAlign = v9892.textAlign;
          }
          v9894.fillStyle = vVO311.scoreText.color;
          v9894.fillText(v9892.text2, 0, v9892.height - 26);
        }
      } else if (v9892.image && v9892.isReady && !v9892.custom) {
        v9894.drawImage(v9892.image, v9923 / 2 - v9892.width / 2, v9924 / 2 - v9892.height / 2, v9892.width, v9892.height);
      } else if (v9892.medal) {
        var vLN01618 = 0;
        var v10097 = v9892.zoom * v9892.scale;
        v9894.translate(UTILS.calcPercent(v9923, v9892.left), UTILS.isNumber(v9892.top) ? UTILS.calcPercent(v9924, v9892.top) : +v9892.top.replace("px", ""));
        if (vVO311.medalPrefab.filter) {
          v9894.filter = vVO311.medalPrefab.filter;
        }
        if (v9902 && v9902.isReady) {
          v9894.drawImage(v9902, -((v9892.size + 10) * v10097 / 2) - v9892.border, vLN01618 - (v9892.size + 10) * v10097 / 2 - v9892.border, (v9892.size + 10) * v10097 + v9892.border * 2, (v9892.size + 10) * v10097 + v9892.border * 2);
        }
        if (v9892.icon && v9892.icon.isReady) {
          v9894.drawImage(v9892.icon, -(v9892.size * 0.325 * v10097) + (v9892.offset.x || 0), vLN01618 - v9892.size * 0.325 * v10097 + (v9892.offset.y || 0), v9892.size * 0.65 * v10097, v9892.size * 0.65 * v10097);
        }
        v9894.font = v10097 * 20 + "px GameFont";
        v9894.strokeStyle = "black";
        v9894.lineWidth = 3;
        v9894.strokeText(v9892.name, 1 - v9894.measureText(v9892.name).width / 2, vLN01618 + v9892.size * v10097 / 2 + v9892.marginName * v9892.scale);
        v9894.fillStyle = "white";
        v9894.fillText(v9892.name, -(v9894.measureText(v9892.name).width / 2), vLN01618 + v9892.size * v10097 / 2 + v9892.marginName * v9892.scale);
        if (v9892.score) {
          v9894.font = v10097 * 18 + "px GameFont";
          v9894.strokeStyle = "black";
          v9894.lineWidth = 3;
          v9894.strokeText(v9892.score, 1 - v9894.measureText(v9892.score).width / 2, vLN01618 + v9892.size * v10097 / 2 + v9892.marginScore * v9892.scale);
          v9894.fillStyle = vVO311.scoreText.color;
          v9894.fillText(v9892.score, -(v9894.measureText(v9892.score).width / 2), vLN01618 + v9892.size * v10097 / 2 + v9892.marginScore * v9892.scale);
        }
        if (v9892.count > 1) {
          var v10098 = "x" + v9892.count;
          v9894.font = v10097 * 25 + "px GameFont";
          v9894.strokeStyle = "black";
          v9894.lineWidth = 3;
          v9894.strokeText(v10098, 1 - v9894.measureText(v10098).width / 2 + v9892.marginCount * v9892.scale, vLN01618 + v9892.size * v10097 / 2);
          v9894.fillStyle = vVO311.scoreText.color;
          v9894.fillText(v10098, -(v9894.measureText(v10098).width / 2) + v9892.marginCount * v9892.scale, vLN01618 + v9892.size * v10097 / 2);
        }
        v9892.zoom -= v9892.zoomInc * (p12555 / 16);
        v9892.zoom = Math.max(1, v9892.zoom);
      }
      v9894.restore(-1);
    }
    if (v9892.delay > 0) {
      v9892.delay -= p12555;
      if (v9892.delay <= 0) {
        v9892.display = true;
        if (v9892.sound && v9892.soundN) {
          SOUND.play(v9892.soundN, 0.08);
        }
      }
    } else {
      if (v9892.scale > v9892.minScale) {
        v9892.scale -= v9892.scaleSpeed * p12555;
        if (v9892.scale <= v9892.minScale) {
          v9892.scale = v9892.minScale;
        }
        v9892.fontSize = v9892.scale;
      }
      if (v9892.scaleSpd) {
        v9892.startS += v9892.scaleSpd * p12555;
        v9892.width = v9892.startS;
        v9892.height = v9892.startS;
      }
      v9892.life -= p12555;
      if (v9892.life <= 0) {
        v9892.display = false;
        var v10099 = v9892.callback;
        vVO311.divs.splice(vLN01620, 1);
        if (v10099) {
          v10099();
        }
      }
      if (v9892.fade && v9892.life <= v9892.fade) {
        v9892.opacity = v9892.life / v9892.fade;
      }
    }
  }
  vVO311.sprayWheelUpdate(p12555);
  if (v9926 && vVO311.sprayWheelOpened() && vVO311.sprayList.length && !v9929) {
    v9894.save(1);
    v9894.translate(v9923 / 2, v9924 / 2);
    var v10111 = v9924 / 2 * 0.4;
    v9894.globalAlpha = 0.7;
    v9894.beginPath();
    v9894.arc(0, 0, v10111, 0, Math.PI * 2, false);
    v9894.fillStyle = "#171717";
    v9894.fill();
    var v10112 = v10111 * 1.33;
    var v10113 = v10111 / 1.9;
    v9894.globalAlpha = 1;
    v9894.lineWidth = v10113;
    v9894.strokeStyle = "#cfcfcf";
    v9894.beginPath();
    v9894.arc(0, 0, v10112, 0, Math.PI * 2, false);
    v9894.stroke();
    var v10103 = vVO311.sprayWheelIndex;
    var v10104 = vVO311.sprayList[v10103];
    var v10116 = Math.PI * 2 / vVO311.sprayList.length;
    var v10117 = v10116 * v10103;
    v9894.strokeStyle = "#55acee";
    v9894.beginPath();
    v9894.arc(0, 0, v10112, v10117, v10117 + v10116, false);
    v9894.stroke();
    var vLN507 = 50;
    var vLN404 = 40;
    var v10118 = v10104.name;
    v9894.fillStyle = v10104.rarity == null ? "#dbdbdb" : game.store.rarities[v10104.rarity].color;
    v9894.font = vLN404 + "px GameFont";
    v9894.fillText(v10118, -v9894.measureText(v10118).width / 2, vLN404 / 2 + vLN507);
    vLN404 = 25;
    v10118 = "Spray";
    v9894.fillStyle = "#a3a3a3";
    v9894.font = vLN404 + "px GameFont";
    v9894.fillText(v10118, -v9894.measureText(v10118).width / 2, vLN404 / 2 + vLN507 + 50);
    var v10119 = vVO311.HELPER.loadImg(v10104.thumbnail);
    if (v10104.frames && v10119) {
      if (v10104.cur == null) {
        v10104.cur = 0;
      }
      if (v10104.dur == null) {
        v10104.dur = v10104.frameT;
      }
      v10104.dur -= p12555;
      if (v10104.dur <= 0) {
        v10104.dur = v10104.frameT;
        v10104.cur++;
        if (v10104.cur >= v10104.frames) {
          v10104.cur = 0;
        }
      }
      v9894.drawImage(v10119, v10119.width / v10104.frames * v10104.cur, 0, v10119.width / v10104.frames, v10119.height, -50, -50 - vLN507 * 1.5, 100, 100);
    } else if (v10119) {
      v9894.drawImage(v10119, -50, -50 - vLN507 * 1.5, 100, 100);
    }
    var v10120 = vVO311.HELPER.loadImg(UTILS.assetsUrl("/img/scroll_2.png"));
    v9894.drawImage(v10120, v10112 + v10113 / 4, -100, 200, 200);
    var v10121 = -(v10116 / 2);
    for (var vLN01620 = 0; vLN01620 < vVO311.sprayList.length; ++vLN01620) {
      v10121 += v10116;
      v10119 = vVO311.HELPER.loadImg(vVO311.sprayList[vLN01620].thumbnail);
      if (v10119.isReady) {
        if (vVO311.sprayList[vLN01620].frames) {
          if (vVO311.sprayList[vLN01620].cur == null) {
            vVO311.sprayList[vLN01620].cur = 0;
          }
          if (vVO311.sprayList[vLN01620].dur == null) {
            vVO311.sprayList[vLN01620].dur = vVO311.sprayList[vLN01620].frameT;
          }
          if (vLN01620 != v10103) {
            vVO311.sprayList[vLN01620].dur -= p12555;
            if (vVO311.sprayList[vLN01620].dur <= 0) {
              vVO311.sprayList[vLN01620].dur = vVO311.sprayList[vLN01620].frameT;
              vVO311.sprayList[vLN01620].cur++;
              if (vVO311.sprayList[vLN01620].cur >= vVO311.sprayList[vLN01620].frames) {
                vVO311.sprayList[vLN01620].cur = 0;
              }
            }
          }
          v9894.drawImage(v10119, v10119.width / vVO311.sprayList[vLN01620].frames * vVO311.sprayList[vLN01620].cur, 0, v10119.width / vVO311.sprayList[vLN01620].frames, v10119.height, v10112 * Math.cos(v10121) - 40, v10112 * Math.sin(v10121) - 40, 80, 80);
        } else {
          v9894.drawImage(v10119, v10112 * Math.cos(v10121) - 40, v10112 * Math.sin(v10121) - 40, 80, 80);
        }
      }
    }
    v9894.restore(-1);
  }
  vVO311.propWheelUpdate(p12555);
  if (v9926 && vVO311.propWheelOpened() && vVO311.propList.length && p12554 && !v9929) {
    v9894.save(1);
    v9894.translate(v9923 / 2, v9924 / 2);
    var v10111 = v9924 / 2 * 0.4;
    v9894.globalAlpha = 0.7;
    v9894.beginPath();
    v9894.arc(0, 0, v10111, 0, Math.PI * 2, false);
    v9894.fillStyle = "#171717";
    v9894.fill();
    var v10112 = v10111 * 1.33;
    var v10113 = v10111 / 1.9;
    v9894.globalAlpha = 1;
    v9894.lineWidth = v10113;
    v9894.strokeStyle = "#cfcfcf";
    v9894.beginPath();
    v9894.arc(0, 0, v10112, 0, Math.PI * 2, false);
    v9894.stroke();
    var v10114 = vVO311.propWheelIndex;
    var v10115 = vVO311.propList[v10114];
    var v10116 = Math.PI * 2 / vVO311.propList.length;
    var v10117 = v10116 * v10114;
    v9894.strokeStyle = "#55acee";
    v9894.beginPath();
    v9894.arc(0, 0, v10112, v10117, v10117 + v10116, false);
    v9894.stroke();
    var vLN507 = 50;
    var vLN404 = 40;
    var v10118 = v10115.name;
    v9894.fillStyle = "#dbdbdb";
    v9894.font = vLN404 + "px GameFont";
    v9894.fillText(v10118, -v9894.measureText(v10118).width / 2, vLN404 / 2 + vLN507);
    vLN404 = 25;
    v10118 = game.mode.propSwitches - (p12554.propSwitches || 0) + " switches left";
    v9894.fillStyle = "#a3a3a3";
    v9894.font = vLN404 + "px GameFont";
    v9894.fillText(v10118, -v9894.measureText(v10118).width / 2, vLN404 / 2 + vLN507 + 50);
    var v10119 = vVO311.HELPER.loadImg(v10115.thumbnail);
    if (v10119.isReady) {
      v9894.drawImage(v10119, -64, -64 - vLN507 * 1.5, 128, 128);
    }
    var v10120 = vVO311.HELPER.loadImg(UTILS.assetsUrl("/img/scroll_2.png"));
    v9894.drawImage(v10120, v10112 + v10113 / 4, -100, 200, 200);
    var v10121 = -(v10116 / 2);
    for (var vLN01620 = 0; vLN01620 < vVO311.propList.length; ++vLN01620) {
      v10121 += v10116;
      v10119 = vVO311.HELPER.loadImg(vVO311.propList[vLN01620].thumbnail);
      if (v10119.isReady) {
        v9894.drawImage(v10119, v10112 * Math.cos(v10121) - 50, v10112 * Math.sin(v10121) - 50, 100, 100);
      }
    }
    v9894.restore(-1);
  }
  var v10122 = window.spectating && spectateUI.style.display != "none";
  if (vVO311.miniMap.enabled && !v9925 && v9926) {
    vVO311.miniMap.update(game, p12552, v9928, p12555, v10122);
  }
  v9892 = vO311.vicTitle;
  if (endUI.style.display != "none" && v9892.show) {
    let v10123 = p12556 / 16;
    v9894.save(1);
    v9894.globalAlpha = v9892.opacity.val;
    v9892.opacity.val += v9892.opacity.increment * v10123;
    v9894.fillStyle = "rgba(0, 0, 0, 0.33)";
    v9894.fillRect(0, 0, v9923, v9924);
    let v10124 = vO312[v9892.type];
    if (v10124 && v10124.isReady) {
      let v10125 = v10124.height * v9892.scale.val;
      let v10126 = v10124.width * v9892.scale.val;
      v9894.drawImage(v10124, (v9923 - v10126) / 2, (v9924 - v10125) / 2, v10126, v10125);
    }
    v9892.scale.val -= v9892.scale.decrement * v10123;
    v9892.scale.val = Math.max(1, v9892.scale.val);
    v9892.scale.decrement += v9892.scale.acc * v10123;
    v9894.restore(-1);
  } else {
    if (v9892.opacity.val != 0) {
      v9892.opacity.val = 0;
    }
    if (v9892.scale.val != 2) {
      v9892.scale.val = 2.5;
    }
    if (v9892.scale.decrement != 0.01) {
      v9892.scale.decrement = 0.01;
    }
  }
  vVO311.fakeCross = false;
  v9894.restore(-1);
};
function f1565(p12559, p12560, p12561, p12562, p12563, p12564, p12565, p12566) {
  v9918.set(p12564.x, p12564.y + 7, p12564.z);
  var v10127 = Math.max(0.3, 1 - UTILS.getD3D(p12565.x, p12565.y, p12565.z, v9918.x, v9918.y, v9918.z) / 600);
  var v10128 = v10127 * 70;
  var v10129 = v10128 >= 1 && p12559.frustum.containPoint(v9918);
  var v10130 = p12566 ? v9897 : v9896;
  if (v10129 && v10130 && v10130.isReady) {
    v9918.project(p12559.camera);
    v9918.x = (v9918.x + 1) / 2;
    v9918.y = (v9918.y + 1) / 2;
    var v10131 = v9918.x * p12561;
    var v10132 = (1 - v9918.y) * p12562;
    var v10133 = p12563 ? p12563.aimVal : 1;
    var v10134 = UTILS.inRange(v10131, p12561 * 0.45, p12561 * 0.55) && UTILS.inRange(v10132, p12562 * 0.4, p12562 * 0.6) && v10133 != 1;
    v9894.globalAlpha = v10134 ? vO311.adsObjectiveOpacity : vO311.objectiveOpacity;
    let v10135 = v10128 / 144;
    v9894.save(1);
    v9894.translate(v10131, v10132);
    v9894.scale(v10135, v10135);
    let vLN803 = 80;
    let vLN1211 = 12;
    let vLN1212 = 12;
    var vLN353 = 35;
    v9894.font = vLN353 + "px GameFont";
    var v10136 = p12566 ? "Next" : p12560.mode.deposit ? "Deposit" : "Capture";
    v9894.fillStyle = "#fff";
    v9894.strokeStyle = "#2e2e2e";
    v9894.lineWidth = 4;
    v9894.textAlign = "center";
    v9894.textBaseline = "middle";
    v9894.strokeText(v10136, 0, -(vLN803 + vLN1211 + vLN1212));
    v9894.fillText(v10136, 0, -(vLN803 + vLN1211 + vLN1212));
    if (!p12566) {
      vLN353 = 35;
      v9894.font = vLN353 + "px GameFont";
      var v10137 = UTILS.getChargedTime(p12560.objtvTime || 0);
      v9894.fillStyle = "#fff";
      v9894.strokeStyle = "#2e2e2e";
      v9894.lineWidth = 4;
      v9894.textAlign = "center";
      v9894.textBaseline = "top";
      v9894.strokeText(v10137, 0, vLN803 + vLN1211 + vLN1212);
      v9894.fillText(v10137, 0, vLN803 + vLN1211 + vLN1212);
    }
    vLN803 = 80;
    v9894.save(1);
    v9894.translate(0.5, 0.5);
    v9894.rotate(Math.PI * 45 / 180);
    v9894.fillStyle = "rgba(0, 0, 0, 0.4)";
    v9894.fillRect(-vLN803 / 2 - vLN1211, -vLN803 / 2 - vLN1211, vLN803 + vLN1211 * 2, vLN803 + vLN1211 * 2);
    v9894.fillStyle = p12566 ? "#fff" : "#FBC02D";
    v9894.fillRect(-vLN803 / 2, -vLN803 / 2, vLN803, vLN803);
    v9894.restore(-1);
    const v10138 = vLN803 * 0.8;
    v9894.drawImage(v10130, -v10138 / 2, -v10138 / 2, v10138, v10138);
    v9894.restore(-1);
  }
}
function f1566(p12567, p12568, p12569, p12570, p12571, p12572) {
  for (var vLN01621 = 0; vLN01621 < vO311.deathMarkers.length; ++vLN01621) {
    v9892 = vO311.deathMarkers[vLN01621];
    if (v9892.life && (v9892.life -= p12568, v9892.life <= 0 && (v9892.life = 0), !UTILS.pointInBox3D(p12572.x, p12572.y, p12572.z, v9892, 10))) {
      v9918.set(v9892.x, v9892.y + 10, v9892.z);
      var v10139 = Math.max(0.3, 1 - UTILS.getD3D(p12572.x, p12572.y, p12572.z, v9918.x, v9918.y, v9918.z) / 600);
      var v10140 = v10139 * 70;
      var v10141 = v10140 >= 1 && p12567.frustum.containPoint(v9918);
      var v10142 = v9892.isYou ? 0 : 2;
      var v10143 = vO311.HELPER.loadImg(UTILS.assetsUrl("/img/death_" + v10142 + "_1.png"));
      if (v10141 && v10143.isReady) {
        v9918.project(p12567.camera);
        v9918.x = (v9918.x + 1) / 2;
        v9918.y = (v9918.y + 1) / 2;
        var v10144 = v9918.x * p12569;
        var v10145 = (1 - v9918.y) * p12570;
        var v10146 = p12571 ? p12571.aimVal : 1;
        var v10147 = UTILS.inRange(v10144, p12569 * 0.45, p12569 * 0.55) && UTILS.inRange(v10145, p12570 * 0.4, p12570 * 0.6) && v10146 != 1;
        v9894.globalAlpha = v10147 ? vO311.deathMarkerAdsOpacity : vO311.deathMarkerOpacity;
        let v10148 = v10140 / v10143.width;
        v9894.save(1);
        v9894.translate(v10144, v10145);
        v9894.scale(v10148, v10148);
        v9894.drawImage(v10143, -v10143.width / 2, -v10143.height / 2);
        v9894.restore(-1);
      }
    }
  }
}
function f1567(p12573, p12574, p12575, p12576, p12577, p12578 = 1, p12579 = false, p12580 = true, p12581 = true) {
  if (p12580) {
    p12573.save(1);
    let vLN224 = 2;
    if (p12581) {
      p12573.fillStyle = vO311.crosshairShadow;
    } else {
      p12573.strokeStyle = vO311.crosshairShadow;
    }
    p12573.lineWidth = p12578;
    p12573.globalAlpha *= 0.5;
    p12573.beginPath();
    if (p12579) {
      p12573.ellipse(p12574 + p12576 / 2, p12575 + p12577 / 2, p12576 / 2 + vLN224, p12577 / 2 + vLN224, 0, 0, Math.PI * 2);
    } else {
      p12573.rect(p12574 - vLN224, p12575 - vLN224, p12576 + vLN224 * 2, p12577 + vLN224 * 2);
    }
    if (p12581) {
      p12573.fill();
    } else {
      p12573.stroke();
    }
    p12573.restore(-1);
  }
  if (p12581) {
    p12573.fillStyle = vO311.crosshairColor;
  } else {
    p12573.strokeStyle = vO311.crosshairColor;
  }
  p12573.lineWidth = p12578;
  p12573.beginPath();
  if (p12579) {
    p12573.ellipse(p12574 + p12576 / 2, p12575 + p12577 / 2, p12576 / 2, p12577 / 2, 0, 0, Math.PI * 2);
  } else {
    p12573.rect(p12574, p12575, p12576, p12577);
  }
  if (p12581) {
    p12573.fill();
  } else {
    p12573.stroke();
  }
}
var vLN1911 = 19;
var vLN1912 = 19;
var vLN1145 = 1;
var vLN314 = 3;
function f1568(p12582) {
  return p12582 * vLN1145 + vLN314;
}
function f1569(p12583) {
  return p12583 / 10 * vLN1911;
}
function f1570(p12584) {
  return p12584 / 10 * vLN1912;
}
function f1571(p12585, p12586, p12587, p12588, p12589, p12590, p12591, p12592, p12593, p12594) {
  p12585.save(1);
  p12585.fillStyle = p12593 || vO311.crosshairColor;
  if (p12589 && !p12591) {
    p12585.strokeStyle = p12594 || vO311.crosshairShadow;
  }
  p12585.lineWidth = 1;
  if (!p12592) {
    p12588 = f1568(p12588);
    p12586 = f1569(p12586);
    p12587 = f1570(p12587) * -1;
  }
  p12585.beginPath();
  if (!p12591) {
    p12585.rotate((p12590 || 0) * Math.PI / 180);
  }
  p12585.rect(-(p12586 / 2), -(p12586 / 2 + (p12591 ? 0 : p12588)), p12586, p12591 ? p12586 : p12587);
  p12585.fill();
  if (p12589 && !p12591) {
    p12585.strokeStyle = p12594 || vO311.crosshairShadow;
    p12585.lineWidth = p12589;
    p12585.stroke();
  }
  p12585.restore(-1);
}
function f1572(p12595, p12596, p12597, p12598, p12599, p12600, p12601) {
  f1571(p12595, p12596, p12597, p12598, p12599, p12600, p12601, false, vO311.crosshairColorM, vO311.crosshairShadowM);
}
CanvasRenderingContext2D.prototype.roundRect = function (p12602, p12603, p12604, p12605, p12606, p12607, p12608) {
  if (typeof p12608 == "undefined") {
    p12608 = true;
  }
  if (typeof p12606 == "undefined") {
    p12606 = 5;
  }
  if (typeof p12606 == "number") {
    p12606 = {
      tl: p12606,
      tr: p12606,
      br: p12606,
      bl: p12606
    };
  } else {
    var vO315 = {
      tl: 0,
      tr: 0,
      br: 0,
      bl: 0
    };
    for (var v10149 in vO315) {
      p12606[v10149] = p12606[v10149] || vO315[v10149];
    }
  }
  this.beginPath();
  this.moveTo(p12602 + p12606.tl, p12603);
  this.lineTo(p12602 + p12604 - p12606.tr, p12603);
  this.quadraticCurveTo(p12602 + p12604, p12603, p12602 + p12604, p12603 + p12606.tr);
  this.lineTo(p12602 + p12604, p12603 + p12605 - p12606.br);
  this.quadraticCurveTo(p12602 + p12604, p12603 + p12605, p12602 + p12604 - p12606.br, p12603 + p12605);
  this.lineTo(p12602 + p12606.bl, p12603 + p12605);
  this.quadraticCurveTo(p12602, p12603 + p12605, p12602, p12603 + p12605 - p12606.bl);
  this.lineTo(p12602, p12603 + p12606.tl);
  this.quadraticCurveTo(p12602, p12603, p12602 + p12606.tl, p12603);
  this.closePath();
  if (p12607) {
    this.fill();
  }
  if (p12608) {
    this.stroke();
  }
};
module.exports = vO311;